import React from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { controlType, ApprovedStatus } from '../../constants/common';
import { allocationConfig, allocationColumnsList } from '../../constants/MockData';
import { apiBatchRequest, apiDelete, apiPost, apiRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import GridTable from '../common/Table/Table';
import { Tooltip, IconButton, TableCell, TextField, Table, TableHead, TableRow, TableBody } from '@material-ui/core';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  cloneDeep,
  applyFilterOnData,
  UpdateColumnWithConfiguration,
  isGridFormValid,
  isDateInCurrentPayCycle,
  isDateInPreviousPayCycle,
  getCurrentPayCycleStartDate,
  isDateInNextPayCycle,
  IsSectionVisible,
  removeDuplicates,
  numberWithCommas,
  GetReadOnlyServiceType,
  with2DecimalsPoints,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';
import { marketRequiredField, propertyRequiredField, DateFormat, propertyDisabledField, SECTIONS, Operators, DataFormat, Markets, ServiceTypes, RECORD_SOURCE } from '../../constants/appConstants';
import Visibility from '@material-ui/icons/Visibility';
import store from '../../store/appStore';
import DailogBoxwithControls from '../common/DailogBoxwithControls/DailogBoxwithControls';
import TimerOffIcon from '@material-ui/icons/TimerOff';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';

class Allocations extends React.PureComponent {
  // Constructor to define state
  constructor(props) {
    super(props);
    const aType = this.props.allocationType !== undefined ? this.props.allocationType[0]?.allocationType : 'Market';

    this.state = {
      allocationData: [],
      departmentMasterData: [],
      departmentFilteredMasterData: [],
      pmaTitleMasterData: [],
      employeeMasterData: [],
      divisionMasterData: [],
      propertyMasterData: [],
      propertyTypeMasterData: [],
      marketMasterData: [],
      configuration: [],
      selectedData: [],
      defaultSelectedData: [],
      selectedEmployeeId: this.props.selectedEmployeeId,
      allocationType: aType,
      selectedAllocationType: aType,
      selectedPropertyId: this.props.selectedPropertyId,
      renderAsChild: this.props.renderAsChild,
      marketId: this.props.marketId,
      selectedEditRowId: undefined,
      isInAddMode: false,
      mode: '',
      updateData: {
        allocationId: 0,
        cloudOrgId: 0,
        userEmail: '',
        propertyId: 0,
        employeeId: 0,
        roleId: 0,
        allocationStartDate: '',
        allocationEndDate: '',
        billingStartDate: '',
        billingEndDate: '',
        marketAllocationPercent: 0,
        propertyAllocationPercent: 0,
        propertyBillingPercent: 0,
        additionalFixedAmount: 0,
        rateValue: 0,
        isReimbursed: false,
        isApproved: true,
        allocationType: '',
        statusId: 0,
        marketId: 0,
        isAllocatedToLegalEntity: false,
        legalEntityId: 0,
        legalEntityAndPropertyData: null,
        previousIsAllocatedToLegalEntity: false,
        approvalId: 0,
        marketName: '',
        propertyName: '',
        divisionId: 0,
        division: '',
        pmaTitleId: 0,
        pmaTitle: ''
      },
      isPopupOpen: false,
      confirmationMessage: '',
      rowIndex: 0,
      allocationColumns: (allocationColumnsList),
      isPreviousToCurrentOrFuture: false,
      postRecord: [],
      isDelete: false,
      previousEditRecord: {},
      isEditableMode: false,
      statusMasterData: [],
      isSave: false,
      originalPropertyData: [],
      allocationTerminationColumn: [],
      isTerminationPopupOpen: false,
      TerminationConfirmationMessage: '',
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };
  }

  // Method to return query with child parameters
  childParameter = (OnlyActiveAllocation = false, supervisorId = []) => {
    let atype = this.state?.selectedAllocationType;
    if (atype === undefined || atype === '') {
      if (this.props.allocationType !== undefined) {
        atype = this.props.allocationType;
      } else {
        const groupName = (((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).accessGroupName || '';
        const roleBasedDefaultAllocationType = groupName.includes('Property') ? 'Property' : 'Market';
        if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION) && roleBasedDefaultAllocationType === 'Market') {
          atype = 'Market';
        } else if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION) && roleBasedDefaultAllocationType === 'Property') {
          atype = 'Property';
        }
      }
    }

    let query = '?OnlyActiveAllocation=' + !OnlyActiveAllocation + '&allocationType=' + (atype || '') + '&';

    if (this.props.renderAsChild) {
      if (this.props.selectedEmployeeId !== undefined) {
        query = query + 'EmployeeId=' + (this.props.selectedEmployeeId || '0') + '&';
      }
      if (this.props.marketId !== undefined && this.props.marketId !== null && this.props.marketId !== '') {
        const allocationType = this.props.allocationType[0]?.allocationType;
        if (allocationType !== 'Property') {
          query = query + 'MarketId=' + (this.props.marketId || '0') + '&';
        }
      }
      if (this.props.selectedLegalEntityId !== undefined && this.props.selectedLegalEntityId !== null && this.props.selectedLegalEntityId !== '') {
        query = query + 'LegalEntityId=' + (this.props.selectedLegalEntityId || '0') + '&';
      }
    }
    const selectedSupervisorId = (supervisorId.map(x => x.ultiProEmployeeId)?.join('|'));
    query = query + 'supervisorId=' + (selectedSupervisorId || '') + '&';
    return query;
  }

  // Method is used to get master data before components are mounted
  componentDidMount() {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 10
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Allocation.GetApprovalStatus,
        key: 'statusMasterData',
        duration: 60
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'divisionMasterData',
        duration: 60
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData + '?outputTypeName=AccessBased',
        key: 'departmentFilteredMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Users.GetPmaTitles,
        key: 'pmaTitleMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Allocation.GetPayPeriod,
        key: 'payPeriodData'
      }
    ])
      .then(
        ({
          employeeMasterData,
          departmentMasterData,
          propertyTypeMasterData,
          marketMasterData,
          propertyMasterData,
          statusMasterData,
          divisionMasterData,
          departmentFilteredMasterData,
          pmaTitleMasterData,
          payPeriodData
        }) => {
          this._asyncRequest = null;
          if (employeeMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          const selectedData = [];
          let serviceTypeId = 0;
          let serviceType = '';
          let allocationType = '';

          if (this.props.renderAsChild && this.props.selectedEmployeeId !== undefined) {
            allocationType = this.props.allocationType[0]?.allocationType;
            if (allocationType === 'Property') {
              serviceTypeId = (employeeMasterData.data.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).serviceTypeId;
              serviceType = (employeeMasterData.data.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).serviceType;
            }
          }

          selectedData.push({
            key: 'onlyActiveAllocation',
            selected: [{ onlyActiveAllocation: false }]
          });
          if (this.props.renderAsChild && allocationType !== 'Property' && this.props.marketId !== undefined && this.props.marketId !== null && this.props.marketId !== '') {
            selectedData.push({
              key: 'marketName',
              selected: (marketMasterData.data || []).filter(
                (x) => x.marketId === parseInt(this.props.marketId)
              )
            });
          }
          let selectedAllocationType = '';
          if (this.props.allocationType !== undefined) {
            selectedData.push({
              key: 'allocationType',
              selected: this.props.allocationType
            });
            selectedAllocationType = this.props.allocationType[0].allocationType;
          } else {
            const groupName = (((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).accessGroupName || '';
            let roleBasedDefaultAllocationType = groupName.includes('Property') ? 'Property' : 'Market';
            if (!(IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION)) && roleBasedDefaultAllocationType === 'Market') {
              roleBasedDefaultAllocationType = 'Property';
            }
            if (!(IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION)) && roleBasedDefaultAllocationType === 'Property') {
              roleBasedDefaultAllocationType = 'Market';
            }
            if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION) && roleBasedDefaultAllocationType === 'Market') {
              selectedData.push({
                key: 'allocationType',
                selected: [{ allocationType: 'Market' }]
              });
              selectedAllocationType = 'Market';
            } else if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION) && roleBasedDefaultAllocationType === 'Property') {
              selectedData.push({
                key: 'allocationType',
                selected: [{ allocationType: 'Property' }]
              });
              selectedAllocationType = 'Property';
            }
          }
          if (this.props.selectedPropertyId !== undefined) {
            selectedData.push({
              key: 'propertyName',
              selected: (propertyMasterData.data || []).filter(
                (x) => x.propertyId === parseInt(this.props.selectedPropertyId)
              )
            });
          }
          if (this.props.selectedEmployeeId !== undefined) {
            selectedData.push({
              key: 'employeeName',
              selected: (employeeMasterData.data || []).filter(
                (x) => x.employeeId === parseInt(this.props.selectedEmployeeId)
              )
            });
          }

          let lastClosedPayPeriodEndDate = new Date('01/01/2000');
          if (((payPeriodData.data || []).filter(x => x.isClosed === true) || []).length > 0) {
            const lastClosedPayPeriod = ((payPeriodData.data || []).filter(x => x.isClosed === true) || []).reduce(function (r, a) {
              return new Date(r.periodEndDate) > new Date(a.periodEndDate) ? r : a;
            });
            lastClosedPayPeriodEndDate = lastClosedPayPeriod.periodEndDate;
          }

          this.setState({
            pmaTitleMasterData: pmaTitleMasterData.data || [],
            statusMasterData: statusMasterData.data || [],
            defaultSelectedData: cloneDeep(selectedData),
            responseEmployeeMasterData: employeeMasterData.data || [],
            employeeMasterData: (this.props.selectedEmployeeId !== undefined && this.props.selectedEmployeeId > 0) ? employeeMasterData.data.filter(x => x.employeeId === this.props.selectedEmployeeId) : employeeMasterData.data || [],
            departmentMasterData: departmentMasterData.data || [],
            propertyTypeMasterData: propertyTypeMasterData.data || [],
            marketMasterData: this.props.marketId !== undefined && this.props.marketId !== null && this.props.marketId !== '' && this.props.renderAsChild && serviceType !== 'Property Accounting'
              ? (marketMasterData.data || []).filter(
                (x) => x.marketId === parseInt(this.props.marketId)
              )
              : marketMasterData.data || [],
            filterPropertyMasterData: propertyMasterData.data || [],
            selectedData: selectedData || [],
            selectedAllocationType,
            divisionMasterData: divisionMasterData.data || [],
            departmentFilteredMasterData: departmentFilteredMasterData.data || [],
            payPeriodData: payPeriodData.data || [],
            lastClosedPayPeriodEndDate: lastClosedPayPeriodEndDate
          }, () => {
            if (this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked || this.props.renderAsChild) {
              this.GetAllocationFromServer(selectedData, false, []);
            }
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Method is used to get allocations records based on selected filters
  GetAllocationFromServer = (selectedData, onlyActiveAllocation, supervisorId) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Allocation.GetAllocationData + this.childParameter(onlyActiveAllocation, supervisorId),
        key: 'allocationData'
      }
    ])
      .then(
        ({
          allocationData
        }) => {
          this._asyncRequest = null;
          if (allocationData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          (allocationData.data || []).forEach(x => {
            if (x.allocationEndDate === undefined || x.allocationEndDate === '0001-01-01T00:00:00') {
              x.allocationEndDate = '5000-01-01T00:00:00';
            }
            if (x.isSwapAllocation === 1 && x.parentSwapAllocationId > 0 && x.parentSwapAllocationId !== x.allocationId) {
              const employeeName = allocationData.data?.find(z => z.allocationId === x.parentSwapAllocationId)?.preferredName || '';
              x.tooltip = 'This is the record created for swapping of Employee ' + employeeName + ' with ' + x.preferredName + ' for Property ' + x.propertyName + '';
            }
          });
          this.setState({
            configuration: allocationData.config || [],
            responseAllocationData: allocationData.data || [],
            allocationData: applyFilterOnData(
              allocationData.data || [],
              selectedData
            ),
            selectedData: selectedData || []
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Method is called when Auto-Run is false. 
  // It reset all the filters when clicked on Reset button and show the message to click on Search button to view data.
  resetPage = (selectedData) => {
    let selectedAllocationType;
    const allocationType =
      selectedData.find((x) => x.key === 'allocationType') || {};
    if (
      allocationType &&
      allocationType.selected &&
      allocationType.selected.length === 1
    ) {
      selectedAllocationType = allocationType.selected[0].allocationType;
    }
    this.setState({
      selectedAllocationType: selectedAllocationType,
      selectedData,
      selectedEditRowId: undefined,
      isInAddMode: false,
      EditedAllcoationRecord: 0,
      isSubmitButtonClicked: false,
      allocationData: [],
      responseAllocationData: null
    });
  }

  // Method is called when clicked on Search or Reset button.
  // It filters the data based on selected filters.
  onFilterChange = (selectedData) => {
    let selectedAllocationType;
    const allocationType =
      selectedData.find((x) => x.key === 'allocationType') || {};
    if (
      allocationType &&
      allocationType.selected &&
      allocationType.selected.length === 1
    ) {
      selectedAllocationType = allocationType.selected[0].allocationType;
    }
    if (selectedData && selectedData.filter(x => x.key === 'onlyActiveAllocation') !== undefined &&
      selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation !==
      this.state.selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation) {
      this.setState({
        selectedAllocationType: selectedAllocationType,
        selectedData,
        selectedEditRowId: undefined,
        isInAddMode: false,
        EditedAllcoationRecord: 0,
        isSubmitButtonClicked: true
      }, () => {
        this.GetAllocationFromServer(selectedData, selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected);
      });
    } else if (selectedData && selectedData.filter(x => x.key === 'ultiProEmployeeId') !== undefined &&
      selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected?.map(x => x.ultiProEmployeeId)?.join('|') !== this.state.selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected?.map(x => x.ultiProEmployeeId)?.join('|')) {
      this.setState({
        selectedAllocationType: selectedAllocationType,
        selectedData,
        selectedEditRowId: undefined,
        isInAddMode: false,
        EditedAllcoationRecord: 0,
        isSubmitButtonClicked: true
      }, () => {
        this.GetAllocationFromServer(selectedData, selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected);
      });
    } else if (selectedAllocationType && selectedAllocationType !==
      this.state.selectedAllocationType) {
      this.setState({
        selectedAllocationType: selectedAllocationType,
        selectedData,
        selectedEditRowId: undefined,
        isInAddMode: false,
        EditedAllcoationRecord: 0,
        isSubmitButtonClicked: this.state.isAutoRunEnabled === true ? true : false, // true
        allocationData: this.state.isAutoRunEnabled === true ? this.state.allocationData : null,
        responseAllocationData: this.state.isAutoRunEnabled === true ? this.state.responseAllocationData : null
      }
        , () => {
          if (this.state.isAutoRunEnabled === true) {
            this.GetAllocationFromServer(selectedData, selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected);
          }
        }
      );
    } else {
      if (this.state.isEditableMode === true) {
        this.setState({
          selectedAllocationType: selectedAllocationType,
          selectedData,
          selectedEditRowId: undefined,
          isInAddMode: false,
          EditedAllcoationRecord: 0,
          isEditableMode: false,
          isSubmitButtonClicked: true
        }, () => {
          this.GetAllocationFromServer(selectedData, selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected);
        });
      } else {
        const { responseAllocationData } = this.state;
        if (responseAllocationData === undefined || responseAllocationData === null) {
          this.setState({
            selectedAllocationType: selectedAllocationType,
            selectedData: selectedData,
            selectedEditRowId: undefined,
            isInAddMode: false,
            EditedAllcoationRecord: 0,
            isSubmitButtonClicked: true
          }, () => {
            this.GetAllocationFromServer(selectedData, selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected);
          });
        } else {
          const filteredData = applyFilterOnData(
            [...responseAllocationData],
            selectedData
          );

          this.setState({
            allocationData: filteredData,
            selectedAllocationType: selectedAllocationType,
            selectedData: selectedData,
            selectedEditRowId: undefined,
            isInAddMode: false,
            EditedAllcoationRecord: 0,
            isSubmitButtonClicked: true
          });
        }
      }
    }
  };

  // Static method used to compare State with Props values. This method always call just before render method
  static getDerivedStateFromProps(newpros, state) {
    if (JSON.stringify(newpros.allocationType && newpros.allocationType[0].allocationType) !==
      JSON.stringify(state.allocationType) ||
      newpros.selectedEmployeeId !== state.selectedEmployeeId ||
      newpros.renderAsChild !== state.renderAsChild
    ) {
      const selectedData = [];

      if (newpros.marketId !== undefined) {
        selectedData.push({
          key: 'marketName',
          selected: (state.marketMasterData.data || []).filter(
            (x) => x.marketId === parseInt(state.marketId)
          )
        });
      }
      if (newpros.allocationType !== undefined) {
        selectedData.push({
          key: 'allocationType',
          selected: newpros.allocationType
        });
      }
      if (newpros.selectedPropertyId !== undefined) {
        selectedData.push({
          key: 'propertyName',
          selected: (state.propertyMasterData || []).filter(
            (x) => x.propertyId === parseInt(newpros.selectedPropertyId)
          )
        });
      }
      if (newpros.selectedEmployeeId !== undefined) {
        selectedData.push({
          key: 'employeeName',
          selected: (state.employeeMasterData || []).filter(
            (x) => x.employeeId === parseInt(newpros.selectedEmployeeId)
          )
        });
      }
      let stateToBeUpdated = {};
      if (JSON.stringify(newpros.allocationType && newpros.allocationType[0].allocationType) !==
        JSON.stringify(state.allocationType)) {
        stateToBeUpdated = {
          selectedEditRowId: undefined,
          isInAddMode: false,
          updateData: {
            allocationId: 0,
            cloudOrgId: 0,
            userEmail: '',
            propertyId: 0,
            employeeId: 0,
            roleId: 0,
            allocationStartDate: '',
            allocationEndDate: '',
            billingStartDate: '',
            billingEndDate: '',
            marketAllocationPercent: 0,
            propertyAllocationPercent: 0,
            propertyBillingPercent: 0,
            additionalFixedAmount: 0,
            rateValue: 0,
            isReimbursed: false,
            isApproved: true,
            allocationType: '',
            statusId: 0,
            marketId: 0,
            isAllocatedToLegalEntity: false,
            legalEntityId: 0,
            legalEntityAndPropertyData: null,
            previousIsAllocatedToLegalEntity: false,
            approvalId: 0,
            marketName: '',
            propertyName: '',
            divisionId: 0,
            division: '',
            pmaTitleId: 0,
            pmaTitle: ''
          }
        };
      }
      return {
        ...stateToBeUpdated,
        allocationType: newpros.allocationType && newpros.allocationType[0].allocationType,
        selectedAllocationType: newpros.allocationType && newpros.allocationType[0].allocationType,
        renderAsChild: newpros.renderAsChild,
        marketId: newpros.marketId,
        selectedEmployeeId: newpros.selectedEmployeeId,
        selectedPropertyId: newpros.selectedPropertyId,
        selectedData: selectedData,
        defaultSelectedData: cloneDeep(selectedData),
        allocationData: applyFilterOnData(
          state.responseAllocationData,
          selectedData
        )
      };
    }
    return null;
  }

  componentWillUnmount() {
    if (this._asyncRequest) {
      // this._asyncRequest.cancel();
    }
  }

  // Method is called when Close/Cancel the Add/Edit record
  close = () => {
    const allocationDataToStore = this.state.allocationData;
    allocationDataToStore.unshift();

    this.GetAllocationFromServer(cloneDeep(this.state.selectedData), this.state.selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, this.state.selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected);

    this.setState({
      isEditableMode: false,
      allocationData: allocationDataToStore,
      selectedEditRowId: undefined,
      isInAddMode: false,
      EditedAllcoationRecord: 0,
      updateData: undefined,
      allocationColumns: cloneDeep(allocationColumnsList)
    });
  };

  // Method is used to enable/disable fields based on allocation type
  setAllocationColumn = (allocationColumns, isStartDateDisable = false, isAllFieldDisable = false, cellInfo) => {
    if (cellInfo.approvalId === ApprovedStatus.Approved) {
      allocationColumns.forEach(x => {
        if (cellInfo.allocationType === 'Property' && cellInfo.isAllocatedToLegalEntity === true && propertyDisabledField.includes(x.key)) {
          x.disabled = true;
        }
        if (x.key === 'marketName') {
          x.disabled = true;
        }
      });
    }
    return allocationColumns;
  }

  // Display selected record in Edit mode. Fill the drop down lists of Employee and Property based on Allocation Start and End Dates.
  EditRecord = async (cellInfo, mode = 'Edit') => {
    const isPreviousPayCycle = isDateInPreviousPayCycle(moment(cellInfo.allocationStartDate).format(DateFormat));
    if (mode === 'Edit' && cellInfo.isSwapAllocation === 1 && cellInfo.childSwapAllocationId > 0) {
      const employeeObj = this.state.responseAllocationData.find(x => x.allocationId === cellInfo.childSwapAllocationId);
      if (employeeObj !== undefined) {
        ShowToast('You can not Edit this record as auto swap is initiated for Employee ' + cellInfo.preferredName + ' with the Employee ' + employeeObj.preferredName + ' for the Property ' + cellInfo.propertyName + ' and it is in Pending Approval status. Please Edit, Delete or Approve that record.', toastType.WARNING, 5000, 500);
      } else {
        ShowToast('You can not Edit this record as auto swap is initiated for Employee ' + cellInfo.preferredName + ' for the Property ' + cellInfo.propertyName + ' and it is in Pending Approval status. Please Edit, Delete or Approve that record.', toastType.WARNING, 5000, 500);
      }
      return;
    }
    let allocationColumns = [
      {
        name: 'Swap Employee Allocation',
        key: 'swapEmployee',
        isRequired: false,
        isVisible: true,
        editSortOrder: 3,
        editConfig: {
          type: controlType.Switch,
          isEditField: true,
          isAddField: true,
          toolTip: 'Swap Employee Allocation'
        }
      }
    ];
    allocationColumns = (mode === 'Edit' && cellInfo.isSwappingAllowed === 1 && (cellInfo.approvalId === ApprovedStatus.Approved || cellInfo.approvalId === ApprovedStatus.AutoAllocated) && cellInfo.allocationType === 'Property')
      ? [...allocationColumns, ...cloneDeep(allocationColumnsList)]
      : cloneDeep(allocationColumnsList);
    let isPreviousToCurrentOrFuture = false;

    if (isPreviousPayCycle && (cellInfo?.approvalId?.toString() === ApprovedStatus.Approved.toString() || cellInfo?.approvalId?.toString() === ApprovedStatus.AutoAllocated.toString())) {
      isPreviousToCurrentOrFuture = true;
    }

    if (cellInfo.allocationEndDate === '0001-01-01T00:00:00') {
      cellInfo.allocationEndDate = null;
    }
    if (cellInfo.billingEndDate === '0001-01-01T00:00:00') {
      cellInfo.billingEndDate = null;
    }
    await this.getPropertyDataFromDate(cellInfo.allocationStartDate, cellInfo.billingStartDate, cellInfo.allocationEndDate, cellInfo.billingEndDate, cellInfo);

    allocationColumns.forEach(x => {
      if (x.key === 'swapEmployee') {
        x.visible = true;
      }
      if (x.key === 'marketName') {
        x.disabled = true;
      }
      if (cellInfo.allocationType === 'Property' && x.key === 'isAllocatedToLegalEntity' && mode === 'Edit' && cellInfo.isSwapAllocation === 1) {
        x.disabled = true;
      }
      if (cellInfo.allocationType === 'Property' && cellInfo.isSwapAllocation === 1 && x.key === 'propertyName') {
        x.disabled = true;
      }
      if (cellInfo.allocationType === 'Property' && cellInfo.isAllocatedToLegalEntity === true && (x.key === 'isAllocatedToLegalEntity' || x.key === 'propertyName' || x.key === 'legalEntity')) {
        x.disabled = true;
      }
      if (cellInfo.allocationType === 'Property' && cellInfo.isAllocatedToLegalEntity === false && (x.key === 'isAllocatedToLegalEntity' || x.key === 'propertyName' || x.key === 'legalEntity') && cellInfo.isAllocatedToLegalEntity === false) {
        const propertyData = this.state.originalPropertyData.filter((x) => x.legalEntity === cellInfo.legalEntity && x.propertyId > 0 && x.marketId.toString() === cellInfo?.marketId?.toString());
        const allocationData = this.state.responseAllocationData.filter(x => x.legalEntity === cellInfo.legalEntity && x.propertyId > 0 && x.marketId.toString() === cellInfo?.marketId?.toString() && x.employeeId.toString() === cellInfo?.employeeId?.toString());
        if (propertyData?.length === allocationData?.length) {
          x.disabled = true;
        }
      }
      if (cellInfo.allocationType === 'Market' && mode === 'Edit' && cellInfo.approvalId === ApprovedStatus.AutoAllocated && (x.key === 'division' || x.key === 'departmentName')) {
        x.disabled = false;
      } else if (x.key === 'division' || x.key === 'departmentName') {
        x.disabled = true;
      }
      if (x.key === 'approvedBy') {
        if (cellInfo.approvalId === ApprovedStatus.RequestedChanges) {
          x.name = 'Changes Suggested By';
        } else {
          x.name = 'Approved By';
        }
      }
      if (x.key === 'approvedOn') {
        if (cellInfo.approvalId === ApprovedStatus.RequestedChanges) {
          x.name = 'Changes Suggested On';
        } else {
          x.name = 'Approved On';
        }
      }
    });
    allocationColumns = this.setAllocationColumn(allocationColumns, false, false, cellInfo);

    cellInfo.legalEntityAndPropertyData = [...(this.setPropertyData(cellInfo.legalEntity, { ...cellInfo }, true))];
    cellInfo.propertyAllocationPercent = cellInfo.isAllocatedToLegalEntity ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce((total, obj) => (parseFloat(obj.propertyAllocationPercent) + parseFloat(total)), 0)) * 100000) / 100000).toFixed(4) : cellInfo.propertyAllocationPercent;
    cellInfo.propertyBillingPercent = cellInfo.isAllocatedToLegalEntity ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce((total1, obj) => (parseFloat(obj.propertyBillingPercent) + parseFloat(total1)), 0)) * 100000) / 100000).toFixed(4) : cellInfo.propertyBillingPercent;
    cellInfo.additionalFixedAmount = cellInfo.isAllocatedToLegalEntity ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce((total1, obj) => (parseFloat(obj.additionalFixedAmount) + parseFloat(total1)), 0)) * 100000) / 100000).toFixed(4) : cellInfo.additionalFixedAmount;

    const cellInfo1 = cloneDeep(cellInfo);
    if (cellInfo1.allocationEndDate === '5000-01-01T00:00:00') {
      cellInfo1.allocationEndDate = null;
    }
    if (cellInfo1.billingEndDate === '5000-01-01T00:00:00') {
      cellInfo1.billingEndDate = null;
    }

    this.setState({
      selectedEditRowId: {
        key: 'allocationId',
        value: cellInfo.allocationId,
        mode: mode
      },
      mode: mode,
      isInAddMode: false,
      updateData: cellInfo1, // cellInfo,
      previousIsAllocatedToLegalEntity: cellInfo.isAllocatedToLegalEntity,
      allocationColumns,
      isPreviousToCurrentOrFuture,
      previousEditRecord: cloneDeep(cellInfo),
      isEditableMode: true,
      isSave: false
    });
  }

  // Method to check whether Termination icon should be visible to the Market Allocation record of the Property Accountant
  // If Property Accountant does not have any active Property Allocation then Market Allocation record of this employee should be available for Termination.
  isTerminationIconVisibleForPropertyAccounting = (cellInfo) => {
    const { lastClosedPayPeriodEndDate, responseAllocationData } = this.state;
    if (cellInfo.allocationType === 'Market' && cellInfo.serviceTypeId === ServiceTypes.Property_Accounting && cellInfo.overallPropertyAllocationPercent === 0 && (cellInfo.marketId?.toString() === Markets.SRP?.toString()) &&
      cellInfo.allocationStartDate <= lastClosedPayPeriodEndDate && (cellInfo.allocationEndDate === null || cellInfo.allocationEndDate === '0001-01-01T00:00:00' || cellInfo.allocationEndDate === '5000-01-01T00:00:00')
    ) {
      const currentPaycyleAllocationData = responseAllocationData.filter(x => x.marketId === cellInfo.marketId && x.employeeId === cellInfo.employeeId &&
        x.departmentId === cellInfo.departmentId && x.divisionId === cellInfo.divisionId && x.approvalId !== ApprovedStatus.Historical
      );

      if ((currentPaycyleAllocationData || []).length > 1) {
        const approvedRecord = currentPaycyleAllocationData.filter(x => x.approvalId !== ApprovedStatus.PendingApproval);
        if (approvedRecord.length > 1) {
          const latest = approvedRecord.reduce(function (r, a) {
            return r.allocationId > a.allocationId ? r : a;
          });
          if (latest.allocationId !== cellInfo.allocationId && (cellInfo.approvalId === ApprovedStatus.Approved || cellInfo.approvalId === ApprovedStatus.AutoAllocated)) {
            return false;
          }
        } else if (cellInfo.approvalId === ApprovedStatus.Approved || cellInfo.approvalId === ApprovedStatus.AutoAllocated) {
          return false;
        }
      }

      const currentPaycylePendingRecords = currentPaycyleAllocationData.filter(x => x.approvalId === ApprovedStatus.PendingApproval);
      if (currentPaycylePendingRecords.length > 0 && cellInfo.approvalId === ApprovedStatus.Approved) {
        return false;
      }
      return true;
    }
    return false;
  }

  // Method to check whether Edit icon is visible for the record.
  isEditIconVisible = (cellInfo) => {
    let isVisible = false;
    if (cellInfo.recordSource === 58 || cellInfo.recordSource === '58' || cellInfo.completeTermination) {
      return false;
    }
    if ((cellInfo.allocationType === 'Property' &&
      IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION) &&
      IsSectionVisible(SECTIONS.ALLOCATIONS, 0, SECTIONS.ADD_EDIT)) ||
      (cellInfo.allocationType === 'Market' &&
        IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION) &&
        IsSectionVisible(SECTIONS.ALLOCATIONS, 0, SECTIONS.ADD_EDIT))) {
      isVisible = true;
      const { responseAllocationData, employeeMasterData } = this.state;
      const serviceTypeList = GetReadOnlyServiceType();
      if (serviceTypeList.find(x => x.serviceTypeId.toString() === cellInfo.serviceTypeId.toString()) !== undefined) {
        return false;
      }
      if (cellInfo.allocationType === 'Market' && cellInfo.serviceTypeId === 3) {
        return false;
      }
      if (cellInfo.allocationType === 'Property' && cellInfo.ptfApprovalId !== 4) {
        return false;
      }

      if (cellInfo.approvalId === ApprovedStatus.Historical) {
        return false;
      }

      // if (cellInfo.allocationType === 'Property' && (cellInfo.allocationEndDate === null || cellInfo.allocationEndDate === '0001-01-01T00:00:00' || cellInfo.allocationEndDate === '5000-01-01T00:00:00')) {
      //   return true;
      // }

      if (cellInfo.allocationType === 'Property') {
        const currentPaycyleAllocationData = responseAllocationData.filter(x => x.marketId === cellInfo.marketId && x.employeeId === cellInfo.employeeId &&
          x.departmentId === cellInfo.departmentId && x.legalEntityId === cellInfo.legalEntityId && x.propertyId === cellInfo.propertyId && x.pmaTitleId === cellInfo.pmaTitleId && x.approvalId !== ApprovedStatus.Historical
        );

        if ((currentPaycyleAllocationData || []).length > 1) {
          const approvedRecord = currentPaycyleAllocationData.filter(x => x.approvalId !== ApprovedStatus.PendingApproval);
          if (approvedRecord.length > 1) {
            const latest = approvedRecord.reduce(function (r, a) {
              return r.allocationId > a.allocationId ? r : a;
            });
            if (latest.allocationId !== cellInfo.allocationId && cellInfo.approvalId === ApprovedStatus.Approved) {
              return false;
            } else if (currentPaycyleAllocationData.length !== approvedRecord.length && cellInfo.approvalId === ApprovedStatus.Approved) {
              return false;
            }
          } else if (cellInfo.approvalId === ApprovedStatus.Approved) {
            return false;
          }
        } else if (cellInfo.allocationEndDate === null || cellInfo.allocationEndDate === '0001-01-01T00:00:00' || cellInfo.allocationEndDate === '5000-01-01T00:00:00') {
          return true;
        }
      }

      if (cellInfo.allocationType === 'Market') {
        const currentPaycyleAllocationData = responseAllocationData.filter(x => x.marketId === cellInfo.marketId && x.employeeId === cellInfo.employeeId &&
          x.departmentId === cellInfo.departmentId && x.divisionId === cellInfo.divisionId && x.approvalId !== ApprovedStatus.Historical
        );

        if ((currentPaycyleAllocationData || []).length > 1) {
          const approvedRecord = currentPaycyleAllocationData.filter(x => x.approvalId !== ApprovedStatus.PendingApproval);
          if (approvedRecord.length > 1) {
            const latest = approvedRecord.reduce(function (r, a) {
              return r.allocationId > a.allocationId ? r : a;
            });
            if (latest.allocationId !== cellInfo.allocationId && (cellInfo.approvalId === ApprovedStatus.Approved || cellInfo.approvalId === ApprovedStatus.AutoAllocated)) {
              return false;
            }
          } else if (cellInfo.approvalId === ApprovedStatus.Approved || cellInfo.approvalId === ApprovedStatus.AutoAllocated) {
            return false;
          }
        }

        const currentPaycylePendingRecords = currentPaycyleAllocationData.filter(x => x.approvalId === ApprovedStatus.PendingApproval);
        if (currentPaycylePendingRecords.length > 0 && cellInfo.approvalId === ApprovedStatus.Approved) {
          return false;
        }
      }
    }
    return isVisible;
  }

  // Method to check whether Delete icon is visible for the record
  isDeleteIconVisible = (cellInfo) => {
    const { lastClosedPayPeriodEndDate } = this.state;
    const serviceTypeList = GetReadOnlyServiceType();
    if (serviceTypeList.find(x => x.serviceTypeId.toString() === cellInfo.serviceTypeId.toString()) !== undefined) {
      return false;
    }
    if (cellInfo.allocationType === 'Property' && cellInfo.ptfApprovalId !== 4) {
      return false;
    }
    if (cellInfo.allocationType === 'Market' && cellInfo.serviceTypeId === ServiceTypes.Property_Accounting && cellInfo.overallPropertyAllocationPercent === 0 && (cellInfo.marketId?.toString() === Markets.SRP?.toString()) &&
      cellInfo.allocationStartDate > lastClosedPayPeriodEndDate
    ) {
      return true;
    }
    if (cellInfo.approvalId !== ApprovedStatus.Approved && cellInfo.approvalId !== ApprovedStatus.AutoAllocated && cellInfo.approvalId !== ApprovedStatus.Historical) {
      return true;
    }
    return false;
  }

  // Method to show Confirmation Box while deleteing selected allocation record.
  DeleteRecord = (cellInfo) => {
    this.setState({
      isPopupOpen: true,
      confirmationMessage: 'Do you want to delete this allocation ?',
      isDelete: true,
      updateData: cellInfo,
      mode: 'View'
    });
  }

  // Method is used to extend the Allocation End Date of the selected record
  ExtendAllocationEndDate = async (cellInfo, mode = 'Edit') => {
    if (mode === 'Edit' && cellInfo.isSwapAllocation === 1 && cellInfo.childSwapAllocationId > 0) {
      const employeeObj = this.state.responseAllocationData.find(x => x.allocationId === cellInfo.childSwapAllocationId);
      ShowToast('You can not Terminate this record as auto swap is initiated for Employee ' + cellInfo.preferredName + ' with the Employee ' + employeeObj.preferredName + ' for the Property ' + cellInfo.propertyName + ' and it is in Pending Approval status. Please Edit, Delete or Approve that record.', toastType.WARNING, 5000, 500);
      return;
    }
    let allocationColumns = cloneDeep(allocationColumnsList);
    const hiddenConfig = [{
      key: 'allocationType',
      value: cellInfo.allocationType
    }];
    allocationColumns = UpdateColumnWithConfiguration(
      allocationColumns,
      this.state.configuration || [],
      hiddenConfig || []
    );
    allocationColumns = this.setAllocationColumn(allocationColumns, false, false, cellInfo);

    if (cellInfo.allocationEndDate === '0001-01-01T00:00:00' || cellInfo.allocationEndDate === '5000-01-01T00:00:00') {
      cellInfo.allocationEndDate = null;
    }
    if (cellInfo.billingEndDate === '0001-01-01T00:00:00' || cellInfo.allocationEndDate === '5000-01-01T00:00:00') {
      cellInfo.billingEndDate = null;
    }
    await this.getPropertyDataFromDate(cellInfo.allocationStartDate, cellInfo.billingStartDate, cellInfo.allocationEndDate, cellInfo.billingEndDate, cellInfo);
    cellInfo.legalEntityAndPropertyData = [...(this.setPropertyData(cellInfo.legalEntity, { ...cellInfo }, true))];
    cellInfo.propertyAllocationPercent = cellInfo.isAllocatedToLegalEntity ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce((total, obj) => (parseFloat(obj.propertyAllocationPercent) + parseFloat(total)), 0)) * 100000) / 100000).toFixed(4) : cellInfo.propertyAllocationPercent;
    cellInfo.propertyBillingPercent = cellInfo.isAllocatedToLegalEntity ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce((total1, obj) => (parseFloat(obj.propertyBillingPercent) + parseFloat(total1)), 0)) * 100000) / 100000).toFixed(4) : cellInfo.propertyBillingPercent;
    cellInfo.additionalFixedAmount = cellInfo.isAllocatedToLegalEntity ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce((total1, obj) => (parseFloat(obj.additionalFixedAmount) + parseFloat(total1)), 0)) * 100000) / 100000).toFixed(4) : cellInfo.additionalFixedAmount;

    allocationColumns.forEach(x => {
      if (x.key === 'allocationEndDate' || x.key === 'billingEndDate') {
        x.disabled = false;
        x.isRequired = true;
      } else {
        x.disabled = true;
      }
      if (x.key === 'approvedBy') {
        if (cellInfo.approvalId === ApprovedStatus.RequestedChanges) {
          x.name = 'Changes Suggested By';
        } else {
          x.name = 'Approved By';
        }
      }
      if (x.key === 'approvedOn') {
        if (cellInfo.approvalId === ApprovedStatus.RequestedChanges) {
          x.name = 'Changes Suggested On';
        } else {
          x.name = 'Approved On';
        }
      }
    });
    this.setState({
      isTerminationPopupOpen: true,
      TerminationConfirmationMessage: 'Allocation Termination',
      updateData: cellInfo,
      previousEditRecord: cloneDeep(cellInfo),
      allocationTerminationColumn: allocationColumns,
      mode: 'View'
    });
  }

  // Handle change event of Allocation End Date and check the validations while doing termination of the record
  handleTerminationAllocationChange = (value, fieldName, row, addMode, index) => {
    const allocationTerminationColumn = this.state.allocationTerminationColumn;
    const param = this.state.updateData;
    const selectedField = (fieldName === 'allocationEndDate') ? allocationTerminationColumn.find((x) => x.key === fieldName && x.allocationType === param.allocationType) : allocationTerminationColumn.find((x) => x.key === fieldName);
    param[fieldName] = value;
    if (value === 'Invalid date') {
      const allocationEndObj = allocationTerminationColumn.find(x => x.key === fieldName);
      allocationEndObj.isVisible = true;
      isGridFormValid(value, allocationEndObj, param);
    } else {
      if (param.allocationType === 'Property' && fieldName === 'allocationEndDate') {
        param.billingEndDate = value;
      }
      isGridFormValid(
        value,
        selectedField,
        param
      );
    }

    if (selectedField.dependentFieldValidation !== undefined && selectedField.dependentFieldValidation.length > 0) {
      selectedField.dependentFieldValidation.forEach(x => {
        if (param[x] !== undefined && param[x] !== '' && param[x] !== null) {
          const ele = (x === 'allocationStartDate' || x === 'allocationEndDate') ? allocationTerminationColumn.find((y) => y.key === x && y.allocationType === param.allocationType) : allocationTerminationColumn.find((y) => y.key === x);
          if (param.allocationType === 'Market' && (x === 'allocationStartDate' || x === 'allocationEndDate')) {
            ele.rules.And = ele.rules.And.filter(x => x.key !== 'billingStartDate' && x.key !== 'billingEndDate');
          }
          isGridFormValid(
            param[x],
            ele,
            param
          );
        }
      });
    }

    this.setState({ updateData: param, allocationTerminationColumn, reloadtable: !this.state.reloadtable }, () => { this.forceUpdate(); });
  }

  // Check the validations while termination of the record
  isValidTermination = (allocationType, allocationColumns) => {
    let IsValid = true;
    const { updateData } = this.state;
    const selectedFields = allocationType === 'Property'
      ? [
        'allocationEndDate',
        'billingEndDate'
      ]
      : [
        'allocationEndDate'
      ];
    allocationColumns.forEach((ele) => {
      if (ele.key === 'billingEndDate') {
        if (updateData.allocationEndDate !== null && (updateData[ele.key] === null || updateData[ele.key] === '' || updateData[ele.key] === undefined)) {
          ele.isRequired = true;
          ele.isVisible = true;
        } else {
          ele.isRequired = false;
          ele.errorMessage = '';
          ele.isVisible = false;
        }
      }
      if (selectedFields.includes(ele.key)) {
        isGridFormValid(updateData[ele.key], ele, updateData);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      }
    });
    this.setState({ allocationTerminationColumn: allocationColumns, updateData }, this.forceUpdate());
    return IsValid;
  };

  // Display record in Edit mode when clicked on Termination Icon. 
  onTerminationPopupClick = (isSave) => {
    const { updateData, allocationTerminationColumn, previousEditRecord } = this.state;
    if (isSave) {
      if (updateData.allocationEndDate !== 'Invalid date' && updateData.billingEndDate !== 'Invalid date' && moment(updateData.allocationEndDate).format(DateFormat) === moment(previousEditRecord.allocationEndDate).format(DateFormat) &&
        moment(updateData.billingEndDate).format(DateFormat) === moment(previousEditRecord.billingEndDate).format(DateFormat)) {
        ShowToast('Please make any changes in the record or click on Cancel.', toastType.WARNING, 5000, 500);
        return false;
      } else if (!this.isValidTermination(updateData.allocationType, allocationTerminationColumn)) {
        return false;
      } else {
        const postBodyData = [];
        if (!updateData.isAllocatedToLegalEntity || updateData.allocationType === 'Market') {
          const data = cloneDeep(this.prepareDataModel(updateData, updateData.propertyId, updateData.allocationId,
            updateData.propertyAllocationPercent, updateData.propertyBillingPercent, updateData.additionalFixedAmount, updateData.approvalId));
          postBodyData.push(data);
        } else {
          const propertyWiseAllocationPercent = with2DecimalsPoints(updateData.legalEntityAndPropertyData.reduce((total, obj) => (parseFloat(obj.propertyAllocationPercent) + parseFloat(total)), 0));
          const propertyWiseBillingPercent = with2DecimalsPoints(updateData.legalEntityAndPropertyData.reduce((total, obj) => (parseFloat(obj.propertyBillingPercent) + parseFloat(total)), 0));
          const additionalFixedAmount = with2DecimalsPoints(updateData.legalEntityAndPropertyData.reduce((total, obj) => (parseFloat(obj.additionalFixedAmount) + parseFloat(total)), 0));

          updateData.legalEntityAndPropertyData.forEach((element, index) => {
            if (index === 0 && parseFloat(updateData.propertyAllocationPercent) !== parseFloat(propertyWiseAllocationPercent) && (parseFloat(updateData.propertyAllocationPercent) - parseFloat(propertyWiseAllocationPercent)) >= 0) {
              let calculatedValue = (parseFloat(updateData.propertyAllocationPercent) - parseFloat(propertyWiseAllocationPercent));
              calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
              element.propertyAllocationPercent = parseFloat(element.propertyAllocationPercent) + parseFloat(calculatedValue);
            }
            if (updateData.isReimbursed && index === 0 && parseFloat(updateData.propertyBillingPercent) !== parseFloat(propertyWiseBillingPercent) && (parseFloat(updateData.propertyBillingPercent) - parseFloat(propertyWiseBillingPercent)) >= 0) {
              let calculatedValue = (parseFloat(updateData.propertyBillingPercent) - parseFloat(propertyWiseBillingPercent));
              calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
              element.propertyBillingPercent = parseFloat(element.propertyBillingPercent) + parseFloat(calculatedValue);
            }
            if (updateData.isReimbursed && index === 0 && parseFloat(updateData.additionalFixedAmount) !== parseFloat(additionalFixedAmount) && (parseFloat(updateData.additionalFixedAmount) - parseFloat(additionalFixedAmount)) >= 0) {
              let calculatedValue = (parseFloat(updateData.additionalFixedAmount) - parseFloat(additionalFixedAmount));
              calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
              element.additionalFixedAmount = parseFloat(element.additionalFixedAmount) + parseFloat(calculatedValue);
            }
            const data = cloneDeep(this.prepareDataModel(updateData, element.propertyId, element.allocationId,
              element.propertyAllocationPercent, element.propertyBillingPercent, element.additionalFixedAmount, element.approvalId));
            postBodyData.push(data);
          });
        }
        this.saveAllocation(postBodyData, { value: updateData.allocationId });
      }
    } else {
      this.setState({
        isTerminationPopupOpen: false,
        TerminationConfirmationMessage: '',
        updateData: undefined,
        allocationTerminationColumn: [],
        allocationData: applyFilterOnData(
          cloneDeep(this.state.responseAllocationData) || [],
          this.state.selectedData
        ),
        reloadtable: !this.state.reloadtable,
        mode: '',
        previousEditRecord: undefined
      }, () => { this.forceUpdate(); this.GetAllocationFromServer(cloneDeep(this.state.selectedData), this.state.selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, this.state.selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected); });
    }
  }

  // Display record wise action buttons like Edit, Save, Cancel etc based on the conditions
  renderActionColumn = (cellInfo, key, isInAddMode, index) => {
    let showAdd = false;
    if (cellInfo.allocationType === 'Market') {
      showAdd = IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION) &&
        IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION, SECTIONS.ADD_EDIT);
    } else if (cellInfo.allocationType === 'Property') {
      showAdd = IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION) &&
        IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION, SECTIONS.ADD_EDIT);
    }
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.allocationId === this.state.selectedEditRowId.value
          ? (
            <>
              {(this.state.selectedEditRowId.mode === 'Edit' || this.state.isInAddMode) &&
                (<Tooltip title="Save Record">
                  <IconButton
                    aria-label={'refreshData'}
                    size="small"
                    onClick={() => { }}
                    disabled={this.state.isSave}
                  >
                    <SaveIcon
                      fontSize="small"
                      size="small"
                      onClick={
                        this.saveUpdatedRecord
                      }
                    />
                  </IconButton>
                </Tooltip>
                )}
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.close}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : (
            <>
              <Tooltip title="View Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can view one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo, 'View');
                    }
                  }}
                >
                  <Visibility fontSize="small" size="small" />
                </IconButton>
              </Tooltip>

              {showAdd && this.isEditIconVisible(cellInfo)
                ? (
                  <Tooltip title="Edit Record">
                    <IconButton
                      aria-label={'refreshData'}
                      size="small"
                      onClick={() => {
                        if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                          ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                          return false;
                        } else {
                          this.EditRecord(cellInfo);
                        }
                      }}
                    >
                      <EditIcon fontSize="small" size="small" />
                    </IconButton>
                  </Tooltip>
                )
                : ''}
              {showAdd && (cellInfo.approvalId === ApprovedStatus.Approved || cellInfo.approvalId === ApprovedStatus.AutoAllocated) &&
                cellInfo.allocationEndDate !== undefined &&
                // (cellInfo.allocationEndDate === undefined || cellInfo.allocationEndDate === '' || cellInfo.allocationEndDate === null || cellInfo.allocationEndDate === '0001-01-01T00:00:00' || !isDateInPreviousPayCycle(moment(cellInfo.allocationEndDate).format(DateFormat))) &&
                (this.isEditIconVisible(cellInfo) || (cellInfo.allocationType === 'Market' && this.isTerminationIconVisibleForPropertyAccounting(cellInfo)))
                ? (
                  <Tooltip title="Terminate Allocation">
                    <IconButton
                      aria-label={'refreshData'}
                      size="small"
                      onClick={() => {
                        if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                          ShowToast('You can add/Edit/Extend one row at a time!', toastType.WARNING, 5000, 500);
                          return false;
                        } else {
                          this.ExtendAllocationEndDate(cellInfo);
                        }
                      }}
                    >
                      <TimerOffIcon fontSize="small" size="small" />
                    </IconButton>
                  </Tooltip>
                )
                : ''}
              {showAdd && this.isDeleteIconVisible(cellInfo)
                ? (<Tooltip title="Delete Record">
                  <IconButton
                    aria-label={'refreshData'}
                    size="small"
                    onClick={() => {
                      this.DeleteRecord(cellInfo);
                    }}
                  >
                    <DeleteIcon fontSize="small" size="small" />
                  </IconButton>
                </Tooltip>)
                : ''
              }
            </>)}
      </>
    );
  };

  // Set Property Data
  setPropertyData = (value, data, isSetValue, fieldName) => {
    const { originalPropertyData, allocationData, responseAllocationData } = this.state;
    const updateData = cloneDeep(data);
    let propertyData = [];
    const dataValue = [];
    if (updateData.isAllocatedToLegalEntity && value !== null && value !== '' && value !== undefined) {
      propertyData = originalPropertyData.filter((x) => x.legalEntity === value && x.propertyId > 0 && x.marketId.toString() === updateData?.marketId?.toString());
      const propertyAllocationPercent = with2DecimalsPoints(updateData.propertyAllocationPercent / propertyData.length);
      const propertyBillingPercent = with2DecimalsPoints(updateData.propertyBillingPercent / propertyData.length);
      const additionalFixedAmount = with2DecimalsPoints(updateData.additionalFixedAmount / propertyData.length);

      propertyData.forEach(data => {
        let isAllocatedToLegalEntity = true;
        updateData.propertyId = data.propertyId;
        updateData.propertyName = data.propertyName;
        let allocationRecord;
        let allocationRecordList = responseAllocationData.filter(x => x.marketId === updateData.marketId && x.employeeId === updateData.employeeId &&
          x.departmentId === updateData.departmentId && x.legalEntityId === data.legalEntityId && x.propertyId === data.propertyId && x.pmaTitleId === updateData.pmaTitleId && x.groupId === updateData.groupId);
        if (updateData.legalEntityAndPropertyData !== undefined) {
          allocationRecordList = updateData.legalEntityAndPropertyData.filter(x => x.marketId === updateData.marketId && x.employeeId === updateData.employeeId &&
            x.departmentId === updateData.departmentId && x.legalEntityId === data.legalEntityId && x.propertyId === data.propertyId && x.pmaTitleId === updateData.pmaTitleId && x.groupId === updateData.groupId);
        }
        if (allocationRecordList === undefined || allocationRecordList?.length === 0) {
          allocationRecordList = responseAllocationData.filter(x => x.marketId === updateData.marketId && x.employeeId === updateData.employeeId &&
            x.departmentId === updateData.departmentId && x.legalEntityId === data.legalEntityId && x.propertyId === data.propertyId && x.pmaTitleId === updateData.pmaTitleId && x.isAllocatedToLegalEntity === false);
          isAllocatedToLegalEntity = false;
        }
        if ((allocationRecordList || []).length > 1) {
          allocationRecord = allocationRecordList.reduce(function (r, a) {
            return r.allocationId > a.allocationId ? r : a;
          });
        } else {
          allocationRecord = (allocationRecordList.find(x =>
            x.isAllocatedToLegalEntity === isAllocatedToLegalEntity && x.employeeId === updateData.employeeId && x.marketId === updateData.marketId &&
            x.propertyId === data.propertyId && x.legalEntityId === data.legalEntityId));
        }
        updateData.propertyAllocationPercent = with2DecimalsPoints(parseFloat(propertyAllocationPercent)); // .toFixed(2);
        updateData.propertyBillingPercent = with2DecimalsPoints(parseFloat(propertyBillingPercent)); // .toFixed(2);
        updateData.additionalFixedAmount = with2DecimalsPoints(parseFloat(additionalFixedAmount), 'Percent'); // .toFixed(2);
        updateData.allocationId = allocationRecord !== undefined ? allocationRecord.allocationId : 0;
        updateData.approvalId = allocationRecord !== undefined ? allocationRecord.approvalId : ApprovedStatus.PendingApproval;
        if (isSetValue) {
          updateData.propertyAllocationPercent = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.propertyAllocationPercent)) : with2DecimalsPoints(0);
          updateData.propertyBillingPercent = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.propertyBillingPercent)) : with2DecimalsPoints(0);
          updateData.additionalFixedAmount = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.additionalFixedAmount)) : with2DecimalsPoints(0);
        }
        if (fieldName === 'propertyAllocationPercent') {
          updateData.propertyBillingPercent = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.propertyBillingPercent)) : propertyBillingPercent;
          updateData.additionalFixedAmount = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.additionalFixedAmount)) : additionalFixedAmount;
        }
        if (fieldName === 'propertyBillingPercent') {
          updateData.propertyAllocationPercent = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.propertyAllocationPercent)) : propertyAllocationPercent;
          updateData.additionalFixedAmount = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.additionalFixedAmount)) : additionalFixedAmount;
        }
        if (fieldName === 'additionalFixedAmount') {
          updateData.propertyAllocationPercent = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.propertyAllocationPercent)) : propertyAllocationPercent;
          updateData.propertyBillingPercent = allocationRecord !== undefined ? with2DecimalsPoints(parseFloat(allocationRecord.propertyBillingPercent)) : propertyBillingPercent;
        }
        dataValue.push({ ...updateData });
      });
    }
    dataValue.forEach(x => {
      x.legalEntityAndPropertyData = undefined;
    });
    return dataValue;
  }

  // Handle change event of the fields on Dynamic Porperties Form when allocation is Legal Entity wise
  handleChangeOnText = (e, index, fieldName) => {
    const { updateData, allocationColumns } = this.state;
    let value = e.target.value;
    if (fieldName === 'Flat Fee') {
      value = with2DecimalsPoints(value, 'Percent');
    } else {
      value = with2DecimalsPoints(value);
    }
    updateData.legalEntityAndPropertyData[index][e.target.name] = value;

    updateData[e.target.name] = updateData.legalEntityAndPropertyData.reduce(
      (total, obj) => (fieldName === 'Flat Fee'
        ? (Math.floor(((parseFloat(obj[e.target.name]) || 0) + parseFloat(total)) * 100000) / 100000).toFixed(2)
        : (Math.floor(((parseFloat(obj[e.target.name]) || 0) + parseFloat(total)) * 100000) / 100000).toFixed(4)),
      0
    );

    if (parseFloat(updateData.legalEntityAndPropertyData[index][e.target.name]) < 0 ||
      (updateData.legalEntityAndPropertyData[index].allocationId !== 0 && !(parseFloat(updateData.legalEntityAndPropertyData[index][e.target.name]) > 0))) {
      updateData.legalEntityAndPropertyData[index][e.target.name + 'IsInErrorState'] = true;
      updateData.legalEntityAndPropertyData[index][e.target.name + 'ErrorMessage'] = parseFloat(updateData.legalEntityAndPropertyData[index][e.target.name]) < 0
        ? fieldName + ' cannot be negative.'
        : fieldName + ' should be greater than 0.';
    } else {
      updateData.legalEntityAndPropertyData[index][e.target.name + 'IsInErrorState'] = false;
      updateData.legalEntityAndPropertyData[index][e.target.name + 'ErrorMessage'] = '';
    }

    const selectedField = allocationColumns.find((x) => x.key === e.target.name);
    if (selectedField.dependentFieldValidation !== undefined && selectedField.dependentFieldValidation.length > 0) {
      selectedField.dependentFieldValidation.forEach(x => {
        if (updateData[x] !== undefined && updateData[x] !== '' && updateData[x] !== null) {
          isGridFormValid(
            updateData[x],
            allocationColumns.find((y) => y.key === x),
            updateData
          );
        }
      });
    }
    isGridFormValid(
      updateData[e.target.name],
      allocationColumns.find((x) => x.key === e.target.name),
      updateData
    );
    this.setState({ updateData, allocationColumns, reloadtable: !this.state.reloadtable }, () => {
      this.forceUpdate();
    });
  }

  // Render Dynamic Form of Properties when Allocation is legal entity wise
  renderDynamicForm = (controlList) => {
    console.log(controlList);
    const { mode } = this.state;
    if (controlList !== undefined) {
      const displayStyle = controlList.isReimbursed ? 'display:block !important' : 'display:none !important';
      return (<Table>
        <TableHead>
          <TableRow>
            <TableCell>Property Name</TableCell>
            <TableCell>Property Allocation Percent</TableCell>
            {controlList.isReimbursed && <TableCell>Property Billing Percent</TableCell>}
            {controlList.isReimbursed && <TableCell>Flat Fee</TableCell>}

          </TableRow>
        </TableHead>
        <TableBody>
          {(controlList.legalEntityAndPropertyData || []).map((col, i) => (
            <TableRow key={i}>
              <TableCell>
                {col.propertyName}
              </TableCell>
              <TableCell>
                {
                  mode !== 'View'
                    ? <TextField
                      margin="normal"
                      size="small"
                      color="primary"
                      className="editable"
                      name="propertyAllocationPercent"
                      type="number"
                      title=""
                      value={col.propertyAllocationPercent}
                      error={col.propertyAllocationPercentIsInErrorState}
                      helperText={col.propertyAllocationPercentErrorMessage}
                      onChange={(e) =>
                        this.handleChangeOnText(
                          e,
                          i,
                          'Property Allocation Percent'
                        )
                      }
                    />
                    // : <>{(numberWithCommas((parseFloat(col.propertyAllocationPercent)?.toFixed(2))))} %</>
                    : <>{(numberWithCommas(parseFloat(col.propertyAllocationPercent)))} %</>
                }

              </TableCell>
              {controlList.isReimbursed &&
                <TableCell>
                  {mode !== 'View'
                    ? <TextField
                      margin="normal"
                      size="small"
                      color="primary"
                      className="editable"
                      name='propertyBillingPercent'
                      type="number"
                      title=""
                      value={controlList.isReimbursed ? col.propertyBillingPercent : 0.00}
                      disabled={!controlList.isReimbursed}
                      error={col.propertyBillingPercentIsInErrorState}
                      helperText={col.propertyBillingPercentErrorMessage}
                      onChange={(e) =>
                        this.handleChangeOnText(
                          e,
                          i,
                          'Property Billing Percent'
                        )
                      }
                    />
                    : <>{(numberWithCommas(parseFloat(col.propertyBillingPercent)))} %</>
                  }
                </TableCell>
              }
              {controlList.isReimbursed &&
                <TableCell>
                  {mode !== 'View'
                    ? <TextField
                      margin="normal"
                      size="small"
                      color="primary"
                      className="editable"
                      name='additionalFixedAmount'
                      type="number"
                      title=""
                      value={controlList.isReimbursed ? col.additionalFixedAmount : 0.00}
                      disabled={!controlList.isReimbursed}
                      error={col.additionalFixedAmountIsInErrorState}
                      helperText={col.additionalFixedAmountErrorMessage}
                      onChange={(e) =>
                        this.handleChangeOnText(
                          e,
                          i,
                          'Flat Fee'
                        )
                      }
                    />
                    : <>${(numberWithCommas(parseFloat(with2DecimalsPoints(col.additionalFixedAmount, 'Percent'))))}</>
                  }
                </TableCell>
              }
            </TableRow>
          ))}
        </TableBody>
      </Table>);
    }
  }

  // Get all the Properties to fill Property drop down list which are active within Allocation Start Date and Allocation End Date.
  getPropertyDataFromDate = async (allocationStartDate, billingStartDate, allocationEndDate, billingEndDate, updateData) => {
    if (allocationStartDate !== undefined & billingStartDate !== undefined && allocationStartDate !== '' & billingStartDate !== '' &&
      allocationStartDate != null & billingStartDate != null && updateData.allocationType !== 'Market' &&
      allocationStartDate !== 'Invalid date' && billingStartDate !== 'Invalid date' && allocationEndDate !== 'Invalid date' && billingEndDate !== 'Invalid date') {
      const params = { allocationStartDate, billingStartDate, allocationEndDate, billingEndDate };
      await apiRequest(
        {
          url: API_URL.Property.GetPropertyLegalEntity,
          params
        }
      )
        .then(({ data: response }) => {
          let propertyData = [];
          const updateData = this.state.updateData;
          const allocationColumns = cloneDeep(allocationColumnsList);
          if (this.props.selectedPropertyId > 0) {
            propertyData = response.filter(x => x.propertyId === this.props.selectedPropertyId);
            if ((propertyData || []).length > 0) {
              updateData.propertyTypeId = (propertyData || [])[0].propertyTypeId;
              updateData.propertyTypeName = (propertyData || [])[0].propertyTypeName;
              updateData.legalEntityId = (propertyData || [])[0].legalEntityId;
              updateData.legalEntity = (propertyData || [])[0].legalEntity;
              updateData.propertyId = (propertyData || [])[0].propertyId;
              updateData.propertyName = (propertyData || [])[0].propertyName;
              updateData.propertyTransitionId = (propertyData || [])[0].propertyTransitionId;
              allocationColumns.forEach(x => {
                if (updateData.allocationType === 'Property' && updateData.isAllocatedToLegalEntity === true && (x.key === 'propertyName' || x.key === 'legalEntity')) {
                  x.disabled = true;
                }
              });
            }
          } else {
            propertyData = response;
          }
          this.setState({ propertyMasterData: propertyData || [], updateData, allocationColumns, reloadtable: !this.state.reloadtable, originalPropertyData: response }, () => {
            if (this.props.selectedPropertyId > 0 && updateData.isAllocatedToLegalEntity) {
              updateData.legalEntityAndPropertyData = [...this.setPropertyData(updateData.legalEntity, { ...updateData })];
              this.setState({ updateData, reloadtable: !this.state.reloadtable });
            }
          });
        }
        )
        .catch(() => {
          this._asyncRequest = null;
        });
    }
  }

  // Handle change event of values of the fields when record is in Edit mode
  handleTableEditChange = async (value, fieldName, row, addMode, index) => {
    const marketData = this.state.marketMasterData;
    const employeeData = this.state.employeeMasterData;
    const propertyData = this.state.propertyMasterData;
    const param = this.state.updateData;
    const allocationColumns = this.state.allocationColumns;
    const divisionData = this.state.divisionMasterData;
    const departmentData = this.state.departmentFilteredMasterData;
    const pmaTitleData = this.state.pmaTitleMasterData;
    let employeeMasterData = this.state.employeeMasterData;

    if (fieldName === 'swapEmployee' && value === false) {
      param.swapEmployee = value;
      const employeeNameObj = allocationColumns.find(x => x.key === 'preferredName' && x.allocationType === 'Property');
      if (employeeNameObj !== undefined && employeeNameObj !== null) {
        employeeNameObj.editConfig.isEditField = false;
        employeeNameObj.errorMessage = '';
        employeeNameObj.isInErrorState = false;
      }
      const allocationStartDateObj = allocationColumns.find(x => x.key === 'allocationStartDate' && x.allocationType === 'Property');
      if (allocationStartDateObj !== undefined && allocationStartDateObj !== null) {
        allocationStartDateObj.errorMessage = '';
        allocationStartDateObj.isInErrorState = false;
      }

      const billingStartDateObj = allocationColumns.find(x => x.key === 'billingStartDate');
      if (billingStartDateObj !== undefined && billingStartDateObj !== null) {
        billingStartDateObj.errorMessage = '';
        billingStartDateObj.isInErrorState = false;
      }

      if (this.state.previousEditRecord?.allocationType === 'Property' && this.state.previousEditRecord?.isAllocatedToLegalEntity === false) {
        const isLegalEntityObj = allocationColumns.find(x => x.key === 'isAllocatedToLegalEntity');
        if (isLegalEntityObj !== undefined && isLegalEntityObj !== null) {
          isLegalEntityObj.editConfig.isEditField = true;
          isLegalEntityObj.disabled = false;
        }
      }
      if (this.state.previousEditRecord?.allocationType === 'Property' && this.state.previousEditRecord?.isAllocatedToLegalEntity === true) {
        const propertyNameObj = allocationColumns.find(x => x.key === 'propertyName');
        if (propertyNameObj !== undefined && propertyNameObj !== null) {
          propertyNameObj.editConfig.isEditField = false;
          propertyNameObj.disabled = true;
        }
      } else {
        const propertyNameObj = allocationColumns.find(x => x.key === 'propertyName');
        if (propertyNameObj !== undefined && propertyNameObj !== null) {
          propertyNameObj.editConfig.isEditField = true;
          propertyNameObj.disabled = false;
        }
      }

      allocationColumns.forEach(x => {
        if (this.state.previousEditRecord?.allocationType === 'Property' && this.state.previousEditRecord?.isAllocatedToLegalEntity === true && (x.key === 'isAllocatedToLegalEntity' || x.key === 'propertyName' || x.key === 'legalEntity')) {
          x.disabled = true;
        }
        if (this.state.previousEditRecord?.allocationType === 'Property' && this.state.previousEditRecord?.isAllocatedToLegalEntity === false && (x.key === 'isAllocatedToLegalEntity' || x.key === 'propertyName' || x.key === 'legalEntity') && this.state.previousEditRecord?.isAllocatedToLegalEntity === false) {
          const propertyData = this.state.originalPropertyData.filter((x) => x.legalEntity === this.state.previousEditRecord?.legalEntity && x.propertyId > 0 && x.marketId.toString() === this.state.previousEditRecord?.marketId?.toString());
          const allocationData = this.state.responseAllocationData.filter(x => x.legalEntity === this.state.previousEditRecord?.legalEntity && x.propertyId > 0 && x.marketId.toString() === this.state.previousEditRecord?.marketId?.toString() && x.employeeId.toString() === this.state.previousEditRecord?.employeeId?.toString());
          if (propertyData?.length === allocationData?.length) {
            x.disabled = true;
          }
        }
      });
      param.employeeId = this.state.previousEditRecord?.employeeId;
      param.preferredName = this.state.previousEditRecord?.preferredName;
      param.allocationStartDate = this.state.previousEditRecord?.allocationStartDate;
      param.allocationEndDate = this.state.previousEditRecord?.allocationEndDate;
      param.billingStartDate = this.state.previousEditRecord?.billingStartDate;
      param.billingEndDate = this.state.previousEditRecord?.billingEndDate;
      param.departmentId = this.state.previousEditRecord?.departmentId;
      param.departmentName = this.state.previousEditRecord?.departmentName;
      param.pmaTitleId = this.state.previousEditRecord?.pmaTitleId;
      param.pmaTitle = this.state.previousEditRecord?.pmaTitle;
      param.burdenRate = this.state.previousEditRecord?.burdenRate;
      param.category = this.state.previousEditRecord?.category;
      param.propertyAllocationPercent = this.state.previousEditRecord?.propertyAllocationPercent;
      param.propertyBillingPercent = this.state.previousEditRecord?.propertyBillingPercent;
      param.additionalFixedAmount = this.state.previousEditRecord?.additionalFixedAmount;
      param.overallMarketAllocationPercent = this.state.previousEditRecord?.overallMarketAllocationPercent;
      param.overallPropertyAllocationPercent = this.state.previousEditRecord?.overallPropertyAllocationPercent;
      param.overallPropertyBillingPercent = this.state.previousEditRecord?.overallPropertyBillingPercent;
      param.isReimbursed = this.state.previousEditRecord?.isReimbursed;
      param.isAllocatedToLegalEntity = this.state.previousEditRecord?.isAllocatedToLegalEntity;
      param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param }, false, fieldName)];
      employeeMasterData = this.state.employeeMasterData;
      if (param.allocationEndDate === '5000-01-01T00:00:00') {
        param.allocationEndDate = null;
      }
      if (param.billingEndDate === '5000-01-01T00:00:00') {
        param.billingEndDate = null;
      }
    } else if (fieldName === 'swapEmployee' && value === true) {
      param.swapEmployee = value;
      param.allocationStartDate = null;
      param.allocationEndDate = null;
      param.billingStartDate = null;
      param.billingEndDate = null;
      param.isAllocatedToLegalEntity = this.state.previousEditRecord?.isAllocatedToLegalEntity;
      param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param }, false, fieldName)];
      const employeeNameObj = allocationColumns.find(x => x.key === 'preferredName' && x.allocationType === 'Property');
      if (employeeNameObj !== undefined && employeeNameObj !== null) {
        employeeNameObj.editConfig.isEditField = true;
      }
      const isLegalEntityObj = allocationColumns.find(x => x.key === 'isAllocatedToLegalEntity');
      if (isLegalEntityObj !== undefined && isLegalEntityObj !== null) {
        isLegalEntityObj.editConfig.isEditField = false;
      }
      const propertyNameObj = allocationColumns.find(x => x.key === 'propertyName');
      if (propertyNameObj !== undefined && propertyNameObj !== null) {
        propertyNameObj.editConfig.isEditField = false;
        propertyNameObj.disabled = false;
      }
      employeeMasterData = this.state.responseEmployeeMasterData;
    }
    if (fieldName === 'isAllocatedToLegalEntity' || fieldName === 'propertyAllocationPercent' || fieldName === 'propertyBillingPercent' || fieldName === 'additionalFixedAmount') {
      param[fieldName] = value;
      if (fieldName !== 'isAllocatedToLegalEntity') {
        param[fieldName] = with2DecimalsPoints(value);
      }
      if (fieldName === 'additionalFixedAmount') {
        param[fieldName] = with2DecimalsPoints(value, 'Percent');
      }
      param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param }, false, fieldName)];
    } else if (fieldName === 'marketName') {
      const valueOfMarket = marketData.find((x) => x.marketName === value);
      param.marketId = (valueOfMarket || {}).marketId;
      param[fieldName] = (valueOfMarket || {}).marketName;
      param.legalEntityId = 0;
      param.legalEntity = '';
      param.propertyId = 0;
      param.propertyName = '';
      param.employeeId = 0;
      param.preferredName = '';
      param.departmentId = 0;
      param.departmentName = '';
      param.burdenRate = 0;
      param.category = '';
      param.overallMarketAllocationPercent = 0;
      param.overallPropertyAllocationPercent = 0;
      param.overallPropertyBillingPercent = 0;
      param.legalEntityAndPropertyData = undefined;
      if (param.marketId !== undefined && (parseInt(param.marketId) !== 6 || parseInt(param.marketId) !== 7)) {
        param.pmaTitleId = 0;
        param.pmaTitle = '';
      }
    } else if (fieldName === 'departmentName') {
      const valueOfDepartment = departmentData.find((x) => x.departmentName === value);
      param[fieldName] = (valueOfDepartment || {}).departmentName;
      param.departmentId = (valueOfDepartment || {}).departmentId;
    } else if (fieldName === 'preferredName') {
      if (param.swapEmployee === true) {
        const empAllocationRecord = this.state.responseAllocationData.find(x =>
          x.preferredName?.toString().trim().toLowerCase() === value?.toString().trim().toLowerCase() &&
          x.legalEntityId === param.legalEntityId &&
          x.isSwapAllocation === 1 && x.parentSwapAllocationId !== x.allocationId);
        if (empAllocationRecord !== undefined && empAllocationRecord !== null) {
          ShowToast('Please select other Employee as Auto Swap record of ' + value + ' is already in Pending Approval state.', toastType.ERROR, 5000, 500);
        }
      }
      const valueOfEmployee = employeeData.find((x) => x.employeeName === value);
      param.employeeId = (valueOfEmployee || {}).employeeId;
      param[fieldName] = (valueOfEmployee || {}).employeeName;
      param.departmentId = (valueOfEmployee || {}).departmentId;
      param.departmentName = (valueOfEmployee || {}).departmentName;
      param.burdenRate = (valueOfEmployee || {}).burdenRate;
      param.category = (valueOfEmployee || {}).category;
      param.overallMarketAllocationPercent = (valueOfEmployee || {}).overallMarketAllocationPercent;
      param.overallPropertyAllocationPercent = (valueOfEmployee || {}).overallPropertyAllocationPercent;
      param.overallPropertyBillingPercent = (valueOfEmployee || {}).overallPropertyBillingPercent;
      if ((param.marketId?.toString() === '6' || param.marketId?.toString() === '7') && param.departmentId?.toString() === '16') {
        const valueOfPmaTitle = pmaTitleData.find((x) => x.pmaTitleId === 1);
        param.pmaTitleId = (valueOfPmaTitle || {}).pmaTitleId;
        param.pmaTitle = (valueOfPmaTitle || {}).pmaTitle;
        allocationColumns.map(x => {
          if (x.key === 'pmaTitle') {
            x.disabled = true;
          }
          return x;
        });
      } else {
        allocationColumns.map(x => {
          if (x.key === 'pmaTitle') {
            x.disabled = false;
          }
          return x;
        });
      }
    } else if (fieldName === 'division') {
      const valueOfDivision = divisionData.find((x) => x.division === value);
      param.divisionId = (valueOfDivision || {}).divisionId;
      param[fieldName] = (valueOfDivision || {}).division;
    } else if (fieldName === 'pmaTitle') {
      const valueOfPmaTitle = pmaTitleData.find((x) => x.pmaTitle === value);
      param.pmaTitleId = (valueOfPmaTitle || {}).pmaTitleId;
      param[fieldName] = (valueOfPmaTitle || {}).pmaTitle;
    } else if (fieldName === 'propertyName' || fieldName === 'legalEntity') {
      let valueOfProperty = {};
      if (fieldName === 'legalEntity') {
        valueOfProperty = propertyData.find((x) => x.legalEntity === value);
        param.propertyTypeId = (valueOfProperty || {}).propertyTypeId;
        param.propertyTypeName = (valueOfProperty || {}).propertyTypeName;
        param.legalEntityId = (valueOfProperty || {}).legalEntityId;
        param[fieldName] = (valueOfProperty || {}).legalEntity;
        param.propertyId = (valueOfProperty || {}).propertyId;
        param.propertyName = (valueOfProperty || {}).propertyName;
        param.propertyTransitionId = (valueOfProperty || {}).propertyTransitionId;
        param.legalEntityAndPropertyData = [...(this.setPropertyData(value, { ...param }))];
      } else {
        valueOfProperty = propertyData.find((x) => x.propertyName === value);
        param.legalEntityId = (valueOfProperty || {}).legalEntityId;
        param.legalEntity = (valueOfProperty || {}).legalEntity;
        param.propertyId = (valueOfProperty || {}).propertyId;
        param[fieldName] = (valueOfProperty || {}).propertyName;
        param.propertyTypeId = (valueOfProperty || {}).propertyTypeId;
        param.propertyTypeName = (valueOfProperty || {}).propertyTypeName;
        param.propertyTransitionId = (valueOfProperty || {}).propertyTransitionId;
      }

      param.propertyTypeId = (valueOfProperty || {}).propertyTypeId;
      param.propertyTypeName = (valueOfProperty || {}).propertyTypeName;
    } else if (fieldName === 'billingStartDate') {
      param[fieldName] = value;
      if (value !== 'Invalid date') {
        await this.getPropertyDataFromDate(param.allocationStartDate, value, param.allocationEndDate, param.billingEndDate, param);
        param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param }, false, fieldName)];
      }
    } else if (fieldName === 'billingEndDate') {
      param[fieldName] = value;
      if (value !== 'Invalid date') {
        await this.getPropertyDataFromDate(param.allocationStartDate, param.billingStartDate, param.allocationEndDate, value, param);
        param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param }, false, fieldName)];
      }
    } else if (fieldName === 'allocationStartDate') {
      if (param.swapEmployee === true &&
        moment(value).format(DateFormat) <= moment(this.state.previousEditRecord?.allocationStartDate).format(DateFormat)) {
        const msg = 'Allocation Start Date should be greater than ' + moment(this.state.previousEditRecord?.allocationStartDate).format('MM/DD/YYYY') + ' for swapping of Employee.';
        ShowToast(msg, toastType.ERROR, 5000, 500);
        param[fieldName] = value;
        param.billingStartDate = value;
        return;
      } else {
        param[fieldName] = value;
        param.billingStartDate = value;
        if (value !== 'Invalid date') {
          await this.getPropertyDataFromDate(value, param.billingStartDate, param.allocationEndDate, param.billingEndDate, param);
          param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param }, false, fieldName)];
        }
      }
    } else if (fieldName === 'allocationEndDate') {
      param[fieldName] = value;
      param.billingEndDate = value;
      if (value !== 'Invalid date') {
        await this.getPropertyDataFromDate(param.allocationStartDate, param.billingStartDate, value, param.billingEndDate, param);
        param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param }, false, fieldName)];
      }
    } else if (fieldName === 'isReimbursed' && value === false) {
      param[fieldName] = value;
      param.propertyBillingPercent = 0.00;
      (param.legalEntityAndPropertyData || []).map(x => { x.propertyBillingPercent = 0.00; return x; });
      const propertyAllocationObj = allocationColumns.find(x => x.key === 'propertyAllocationPercent');
      propertyAllocationObj.isInErrorState = false;
      propertyAllocationObj.errorMessage = '';
    } else if (fieldName === 'isReimbursed' && value === true) {
      param[fieldName] = value;
      param.additionalFixedAmount = 0;
      param.propertyBillingPercent = param.propertyAllocationPercent;
      param.legalEntityAndPropertyData = [...this.setPropertyData(param.legalEntity, { ...param })];
      const propertybillingObj = allocationColumns.find(x => x.key === 'propertyBillingPercent');
      propertybillingObj.isInErrorState = false;
      propertybillingObj.errorMessage = '';
      const propertyAllocationObj = allocationColumns.find(x => x.key === 'propertyAllocationPercent');
      propertyAllocationObj.isInErrorState = false;
      propertyAllocationObj.errorMessage = '';
    } else {
      param[fieldName] = value;
    }

    param.statusId = param.statusId === 0 ? 1 : param.statusId;

    const selectedField = (fieldName === 'preferredName' || fieldName === 'allocationStartDate' || fieldName === 'allocationEndDate') ? allocationColumns.find((x) => x.key === fieldName && x.allocationType === param.allocationType) : allocationColumns.find((x) => x.key === fieldName);

    if (value === 'Invalid date') {
      const allocationEndObj = allocationColumns.find(x => x.key === fieldName);
      allocationEndObj.isVisible = true;
      isGridFormValid(value, allocationEndObj, param);
    } else {
      if (fieldName === 'allocationEndDate') {
        if (param.allocationType === 'Property') {
          const allocationEndObj = allocationColumns.find(x => x.key === 'billingEndDate');
          allocationEndObj.isVisible = true;
          if (value !== null && value !== undefined && value !== '') {
            if (param.billingEndDate === null) {
              allocationEndObj.isRequired = true;
            } else {
              allocationEndObj.isRequired = false;
              allocationEndObj.isInErrorState = false;
            }
          } else {
            allocationEndObj.isRequired = false;
            allocationEndObj.isInErrorState = false;
          }
          isGridFormValid(param.billingEndDate, allocationEndObj, param);
        }
      } else if (fieldName === 'billingEndDate') {
        if (param.allocationType === 'Property') {
          const allocationEndObj = allocationColumns.find(x => x.key === 'billingEndDate');
          allocationEndObj.isVisible = true;
          if (param.allocationEndDate !== null && param.allocationEndDate !== undefined && param.allocationEndDate !== '') {
            if (value === null) {
              allocationEndObj.isRequired = true;
            } else {
              allocationEndObj.isRequired = false;
              allocationEndObj.isInErrorState = false;
            }
          } else {
            allocationEndObj.isRequired = false;
            allocationEndObj.isInErrorState = false;
          }
          isGridFormValid(param.billingEndDate, allocationEndObj, param);
        }
      }
      isGridFormValid(
        value,
        selectedField,
        param
      );
    }

    if (selectedField.dependentFieldValidation !== undefined && selectedField.dependentFieldValidation.length > 0) {
      selectedField.dependentFieldValidation.forEach(x => {
        if (param[x] !== undefined && param[x] !== '' && param[x] !== null) {
          const ele = (x === 'allocationStartDate' || x === 'allocationEndDate') ? allocationColumns.find((y) => y.key === x && y.allocationType === param.allocationType) : allocationColumns.find((y) => y.key === x);
          if (param.allocationType === 'Market' && (x === 'allocationStartDate' || x === 'allocationEndDate')) {
            ele.rules.And = ele.rules.And.filter(x => x.key !== 'billingStartDate' && x.key !== 'billingEndDate');
          }
          isGridFormValid(
            param[x],
            ele,
            param
          );
        }
      });
    }
    this.setState({ updateData: param, allocationColumns, reloadtable: !this.state.reloadtable, employeeMasterData: employeeMasterData }, () => { this.forceUpdate(); });
  };

  // Check validations on Edit record form
  validateForm = () => {
    const { updateData, employeeMasterData, originalPropertyData } = this.state;
    if (updateData.isReimbursed && updateData.allocationType === 'Property' &&
      ((updateData.propertyBillingPercent !== null && parseFloat(updateData.propertyBillingPercent) === 0 &&
        updateData.additionalFixedAmount !== null && parseFloat(updateData.additionalFixedAmount) === 0) ||
        (updateData.propertyBillingPercent !== null && parseFloat(updateData.propertyBillingPercent) > 0 &&
          updateData.additionalFixedAmount !== null && parseFloat(updateData.additionalFixedAmount) > 0))) {
      const msg = 'You can enter either Flat Fee Amount or Property Billing Percent';
      ShowToast(msg, toastType.ERROR, 5000, 500);
      return false;
    } else if (updateData.allocationType === 'Property' && updateData.employeeId > 0 && (updateData.legalEntityId > 0 || updateData.propertyId > 0)) {
      const empData = employeeMasterData.find(x => x.employeeId === updateData.employeeId);
      let legalEntityData;
      if (updateData.legalEntityId !== null && updateData.legalEntityId !== '' && updateData.legalEntityId !== undefined) {
        legalEntityData = originalPropertyData.find(x => x.legalEntityId === updateData.legalEntityId);
      } else {
        legalEntityData = originalPropertyData.find(x => x.propertyId === updateData.propertyId);
      }
      if (legalEntityData !== undefined) {
        const serviceType = (legalEntityData.serviceType || '').split('|');
        if (empData !== undefined) {
          const service = serviceType.find(y => y === empData.serviceType);
          if (service !== undefined) return true;
        }
      }
      let msg = '';
      if (updateData.isAllocatedToLegalEntity) {
        msg = 'There is no active assignment having service type as ' + (empData !== undefined ? empData.serviceType : '') + ' for legal entity ' + updateData.legalEntity + ' . Hence employee from this department ' + updateData.departmentName + ' cannot be allocated.';
      } else {
        msg = 'There is no active assignment having service type as ' + (empData !== undefined ? empData.serviceType : '') + ' for property ' + updateData.propertyName + ' . Hence employee from this department ' + updateData.departmentName + ' cannot be allocated.';
      }
      ShowToast(msg, toastType.ERROR, 5000, 500);
      return false;
    }
    return true;
  }

  // Check whether form values are correct. Validations on each field will be checked here.
  // It return true/false values based on validations
  isValidForm = (allocationType, allocationColumns, isTermination = false) => {
    let IsValid = true;
    const { updateData } = this.state;
    const selectedFieldList = allocationType === 'Property' ? propertyRequiredField : marketRequiredField;
    let selectedFields = cloneDeep(selectedFieldList);
    allocationColumns.forEach((ele) => {
      if (allocationType === 'Market' && ele.key === 'allocationStartDate') {
        ele.rules.And = ele.rules.And.filter(x => x.key !== 'billingStartDate' && x.key !== 'billingEndDate');
      }
      if (isTermination === false) {
        if (ele.key === 'billingEndDate') {
          if (updateData.allocationEndDate !== null && (updateData[ele.key] === null || updateData[ele.key] === '' || updateData[ele.key] === undefined)) {
            ele.isRequired = true;
            ele.isVisible = true;
          } else {
            ele.isRequired = false;
            ele.errorMessage = '';
            ele.isVisible = false;
          }
        }
      }
      if (allocationType === 'Property') {
        if (ele.key === 'propertyBillingPercent') {
          ele.isInErrorState = false;
          ele.errorMessage = '';
        }
        selectedFields = (updateData.isReimbursed === false)
          ? selectedFields.filter(x => x !== 'propertyBillingPercent')
          : (updateData.isReimbursed === true && updateData.additionalFixedAmount !== null && updateData.additionalFixedAmount !== undefined && parseFloat(updateData.additionalFixedAmount) <= 0)
            ? selectedFields
            : selectedFields.filter(x => x !== 'propertyBillingPercent');
        selectedFields = (updateData.marketId !== undefined && (parseInt(updateData.marketId) === 6))
          ? selectedFields
          : (updateData.marketId !== undefined && parseInt(updateData.marketId) === 7)
            ? selectedFields
            : selectedFields.filter(x => x !== 'pmaTitle');
      }

      if (selectedFields.includes(ele.key)) {
        isGridFormValid(updateData[ele.key], ele, updateData);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      }
    });
    if (allocationType === 'Property' && updateData.isAllocatedToLegalEntity && updateData.legalEntityAndPropertyData.length > 0) {
      // Block save if every property row is 0% — at least one must carry a value.
      const hasAtLeastOneNonZero = updateData.legalEntityAndPropertyData.some(form => parseFloat(form.propertyAllocationPercent) > 0);
      if (!hasAtLeastOneNonZero) {
        IsValid = false;
        ShowToast('At least one property must have allocation percent greater than 0.', toastType.ERROR, 5000, 500);
      }
      updateData.legalEntityAndPropertyData.forEach(form => {
        // A 0% row is only allowed to be skipped if it has NO existing allocation (allocationId === 0).
        // Those are new/unallocated properties the user intentionally left at 0%.
        if (form.allocationId === 0 && (parseFloat(form.propertyAllocationPercent) === 0 || form.propertyAllocationPercent === 0.00)) {
          form.propertyAllocationPercentIsInErrorState = false;
          form.propertyAllocationPercentErrorMessage = '';
          form.propertyBillingPercentIsInErrorState = false;
          form.propertyBillingPercentErrorMessage = '';
          form.additionalFixedAmountIsInErrorState = false;
          form.additionalFixedAmountErrorMessage = '';
          return;
        }
        if (form.allocationId !== 0 && (parseFloat(form.propertyAllocationPercent) === 0 ||
          form.propertyAllocationPercent === 0.00)) {
          form.propertyAllocationPercentIsInErrorState = true;
          form.propertyAllocationPercentErrorMessage = 'Property Allocation Percent should be greater than 0.';
          IsValid = false;
        } else {
          form.propertyAllocationPercentIsInErrorState = false;
          form.propertyAllocationPercentErrorMessage = '';
        }
        if ((form.allocationId !== 0 || parseFloat(form.propertyAllocationPercent) > 0) && updateData.isReimbursed && updateData.propertyBillingPercent > 0 && (parseFloat(updateData.additionalFixedAmount) === 0 || updateData.additionalFixedAmount === 0 || updateData.additionalFixedAmount === null || updateData.additionalFixedAmount === undefined || updateData.additionalFixedAmount === '') && !(parseFloat(form.propertyBillingPercent) > 0)) {
          form.propertyBillingPercentIsInErrorState = true;
          form.propertyBillingPercentErrorMessage = 'Property Billing Percent should be greater than 0.';
          IsValid = false;
        } else if ((form.allocationId !== 0 || parseFloat(form.propertyAllocationPercent) > 0) && updateData.isReimbursed && updateData.additionalFixedAmount > 0 && (parseFloat(updateData.propertyBillingPercent) === 0 || updateData.propertyBillingPercent === 0 || updateData.propertyBillingPercent === null || updateData.propertyBillingPercent === undefined || updateData.propertyBillingPercent === '') && !(parseFloat(form.additionalFixedAmount) > 0)) {
          form.additionalFixedAmountIsInErrorState = true;
          form.additionalFixedAmountErrorMessage = 'Flat fee should be greater than 0.';
          IsValid = false;
        } else {
          form.propertyBillingPercentIsInErrorState = false;
          form.propertyBillingPercentErrorMessage = '';
          form.additionalFixedAmountIsInErrorState = false;
          form.additionalFixedAmountErrorMessage = '';
        }
      });
    }
    if (isTermination) {
      this.setState({ allocationTerminationColumn: allocationColumns, updateData }, this.forceUpdate());
    } else {
      this.setState({ allocationColumns, updateData }, this.forceUpdate());
    }
    return IsValid;
  };

  // Method to check whether selected employee is of Proprty Accounting Department
  isPropertyAccountingEmployee = () => {
    const { updateData, employeeMasterData, selectedAllocationType } = this.state;
    let isValid = true;
    const empData = employeeMasterData.find(x => x.employeeId === updateData.employeeId);
    if (selectedAllocationType === 'Market' && empData?.serviceTypeId?.toString() === '3') {
      isValid = false;
      ShowToast('Property Accountant(s) cannot be added explicitly to other market.', toastType.ERROR, 5000, 500);
    }
    return isValid;
  }

  // Method is used to save the updated record
  // Validations will be checked before saving the record in database
  saveUpdatedRecord = () => {
    const { previousIsAllocatedToLegalEntity, updateData, selectedEditRowId, selectedAllocationType, allocationColumns } = this.state;
    if (updateData.swapEmployee === true) {
      if (moment(updateData.allocationStartDate).format(DateFormat) <= moment(this.state.previousEditRecord?.allocationStartDate).format(DateFormat)) {
        const msg = 'Allocation Start Date should be greater than ' + moment(this.state.previousEditRecord?.allocationStartDate).format('MM/DD/YYYY') + ' for swapping of Employee.';
        ShowToast(msg, toastType.ERROR, 5000, 500);
        return false;
      }

      if (updateData.employeeId === this.state.previousEditRecord?.employeeId) {
        const msg = 'Please select employee other than ' + this.state.previousEditRecord?.preferredName + ' for swapping of Employee.';
        ShowToast(msg, toastType.ERROR, 5000, 500);
        return false;
      }
    }
    if (!this.isValidForm(selectedAllocationType, allocationColumns) || !this.validateForm() || !this.isPropertyAccountingEmployee()) {
      return false;
    }
    const postBodyData = [];
    if (!updateData.isAllocatedToLegalEntity || updateData.allocationType === 'Market') {
      const data = this.prepareDataModel(updateData, updateData.propertyId, selectedEditRowId.value,
        updateData.propertyAllocationPercent, updateData.propertyBillingPercent, updateData.additionalFixedAmount, updateData.approvalId);
      postBodyData.push(data);
    } else {
      const propertyWiseAllocationPercent = with2DecimalsPoints(updateData.legalEntityAndPropertyData.reduce((total, obj) => ((parseFloat(obj.propertyAllocationPercent) || 0) + parseFloat(total)), 0));
      const propertyWiseBillingPercent = with2DecimalsPoints(updateData.legalEntityAndPropertyData.reduce((total, obj) => ((parseFloat(obj.propertyBillingPercent) || 0) + parseFloat(total)), 0));
      const additionalFixedAmount = with2DecimalsPoints(updateData.legalEntityAndPropertyData.reduce((total, obj) => ((parseFloat(obj.additionalFixedAmount) || 0) + parseFloat(total)), 0));
      updateData.legalEntityAndPropertyData.forEach((element, index) => {
        if (element.allocationId === 0 && !(parseFloat(element.propertyAllocationPercent) > 0)) {
          return; // property at 0% or blank — skip, no allocation will be created
        }
        if (updateData.swapEmployee === true && element.allocationId === 0) {
          let allocationRecord;
          const originalRecord = this.state.previousEditRecord;
          const allocationRecordList = this.state.responseAllocationData.filter(x => x.marketId === element.marketId && x.employeeId === originalRecord.employeeId &&
            x.departmentId === originalRecord.departmentId && x.legalEntityId === element.legalEntityId && x.propertyId === element.propertyId && x.pmaTitleId === originalRecord.pmaTitleId && x.groupId === element.groupId);

          if ((allocationRecordList || []).length > 1) {
            allocationRecord = allocationRecordList.reduce(function (r, a) {
              return r.allocationId > a.allocationId ? r : a;
            });
          } else {
            allocationRecord = (allocationRecordList.find(x =>
              x.isAllocatedToLegalEntity === updateData.isAllocatedToLegalEntity && x.employeeId === originalRecord.employeeId && x.marketId === element.marketId &&
              x.propertyId === element.propertyId && x.legalEntityId === element.legalEntityId));
          }
          element.allocationId = allocationRecord !== undefined ? allocationRecord.allocationId : 0;
        }
        if (index === 0 && parseFloat(updateData.propertyAllocationPercent) !== parseFloat(propertyWiseAllocationPercent) && (parseFloat(updateData.propertyAllocationPercent) - parseFloat(propertyWiseAllocationPercent)) >= 0) {
          let calculatedValue = (parseFloat(updateData.propertyAllocationPercent) - parseFloat(propertyWiseAllocationPercent));
          calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
          element.propertyAllocationPercent = parseFloat(element.propertyAllocationPercent) + parseFloat(calculatedValue);
        }
        if (updateData.isReimbursed && index === 0 && parseFloat(updateData.propertyBillingPercent) !== parseFloat(propertyWiseBillingPercent) && (parseFloat(updateData.propertyBillingPercent) - parseFloat(propertyWiseBillingPercent)) >= 0) {
          let calculatedValue = (parseFloat(updateData.propertyBillingPercent) - parseFloat(propertyWiseBillingPercent));
          calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
          element.propertyBillingPercent = parseFloat(element.propertyBillingPercent) + parseFloat(calculatedValue);
        }
        if (updateData.isReimbursed && index === 0 && parseFloat(updateData.additionalFixedAmount) !== parseFloat(additionalFixedAmount) && (parseFloat(updateData.additionalFixedAmount) - parseFloat(additionalFixedAmount)) >= 0) {
          let calculatedValue = (parseFloat(updateData.additionalFixedAmount) - parseFloat(additionalFixedAmount));
          calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(2);
          element.additionalFixedAmount = (parseFloat(element.additionalFixedAmount) + parseFloat(calculatedValue)).toFixed(2);
        }
        const data = this.prepareDataModel(updateData, element.propertyId, element.allocationId,
          element.propertyAllocationPercent, element.propertyBillingPercent, element.additionalFixedAmount, element.approvalId);
        postBodyData.push(data);
      });
    }
    if (selectedAllocationType === 'Property' &&
      previousIsAllocatedToLegalEntity !== updateData.isAllocatedToLegalEntity &&
      selectedEditRowId.value > 0) {
      const msg = updateData.isAllocatedToLegalEntity ? 'Are you sure you want to change property to legal entity?' : 'Are you sure you want to change legal entity to property?';
      this.setState({ isPopupOpen: true, confirmationMessage: msg, postRecord: postBodyData });
    } else {
      this.isAllocationExits(postBodyData);
    }
  };

  // Method is used to create allocation data model required to save into database
  prepareDataModel = (newParam, propertyId, allocationId, propertyAllocationPercent, propertyBillingPercent, additionalFixedAmount, approvalId) => {
    return {
      departmentId: newParam.departmentId,
      propertyId: propertyId,
      employeeId: newParam.employeeId,
      allocationStartDate: moment(newParam.allocationStartDate).format(
        'YYYY/MM/DD'
      ),
      allocationEndDate: (newParam.allocationEndDate != null && newParam.allocationEndDate !== '' && newParam.allocationEndDate !== undefined)
        ? moment(newParam.allocationEndDate).format(
          'YYYY/MM/DD'
        )
        : null,
      billingStartDate: newParam.allocationType === 'Property'
        ? moment(newParam.billingStartDate).format(
          'YYYY/MM/DD'
        )
        : null,
      billingEndDate: (newParam.billingEndDate != null && newParam.billingEndDate !== '' && newParam.billingEndDate !== undefined) ? moment(newParam.billingEndDate).format('YYYY/MM/DD') : null,
      marketAllocationPercent: newParam.marketAllocationPercent != null && newParam.marketAllocationPercent !== '' && newParam.marketAllocationPercent !== undefined
        ? newParam.marketAllocationPercent
        : 0,
      propertyAllocationPercent: propertyAllocationPercent !== null && propertyAllocationPercent !== '' && propertyAllocationPercent !== undefined ? parseFloat(propertyAllocationPercent) : 0,
      propertyBillingPercent: propertyBillingPercent !== null && propertyBillingPercent !== '' && propertyBillingPercent !== undefined ? parseFloat(propertyBillingPercent) : 0,
      additionalFixedAmount: additionalFixedAmount !== null && additionalFixedAmount !== '' && additionalFixedAmount !== undefined ? parseFloat(additionalFixedAmount) : 0,
      rateValue: newParam.rateValue,
      isReimbursed: newParam.isReimbursed,
      isApproved: newParam.isApproved,
      allocationType: newParam.allocationType,
      statusId: 1,
      marketId: parseInt(newParam.marketId),
      isAllocatedToLegalEntity: newParam.isAllocatedToLegalEntity,
      legalEntityId: newParam.legalEntityId,
      allocationId: allocationId,
      approvalStatusId: ApprovedStatus.PendingApproval,
      marketName: newParam.marketName,
      propertyName: newParam.propertyName,
      recordSource: newParam.allocationType === 'Property' ? 8 : 0,
      propertyTransitionId: newParam.propertyTransitionId,
      divisionId: newParam.divisionId,
      pmaTitleId: newParam.pmaTitleId
    };
  }

  // Method is used to compare and check whether current and Previous objects are equal or not
  isEqual = (current, prev, allocationType) => {
    if (allocationType === 'Property' && current.employeeId?.toString() === prev.employeeId?.toString() && current.marketId?.toString() === prev.marketId?.toString() &&
      current.departmentId?.toString() === prev.departmentId?.toString() && current.pmaTitleId?.toString() === prev.pmaTitleId?.toString() && moment(current.allocationStartDate).format(DateFormat) === moment(prev.allocationStartDate).format(DateFormat) &&
      moment(current.allocationEndDate).format(DateFormat) === moment(prev.allocationEndDate).format(DateFormat) && moment(current.billingStartDate).format(DateFormat) === moment(prev.billingStartDate).format(DateFormat) &&
      moment(current.billingEndDate).format(DateFormat) === moment(prev.billingEndDate).format(DateFormat) && parseFloat(current.propertyAllocationPercent).toFixed(4) === parseFloat(prev.propertyAllocationPercent).toFixed(4) &&
      current.isAllocatedToLegalEntity === prev.isAllocatedToLegalEntity && current.isReimbursed === prev.isReimbursed && parseFloat(current.propertyBillingPercent) === parseFloat(prev.propertyBillingPercent) && parseFloat(current.additionalFixedAmount) === parseFloat(prev.additionalFixedAmount)) {
      return true;
    } else if (allocationType === 'Market' && current.employeeId?.toString() === prev.employeeId?.toString() && current.marketId?.toString() === prev.marketId?.toString() &&
      current.departmentId?.toString() === prev.departmentId?.toString() && current.divisionId?.toString() === prev.divisionId?.toString() && moment(current.allocationStartDate).format(DateFormat) === moment(prev.allocationStartDate).format(DateFormat) &&
      moment(current.allocationEndDate).format(DateFormat) === moment(prev.allocationEndDate).format(DateFormat) && parseFloat(current.marketAllocationPercent).toFixed(4) === parseFloat(prev.marketAllocationPercent).toFixed(4)) {
      return true;
    }
    return false;
  }

  // Method is used to check whether duplicate allocation record is exists or not
  isAllocationExits = (postRecord) => {
    const { updateData, selectedEditRowId, isPreviousToCurrentOrFuture, previousEditRecord, responseAllocationData, lastClosedPayPeriodEndDate } = this.state;
    let message = '';
    let isSave = false;
    let isShowPopUp = false;
    const trueUpMsg = 'This is a backdated Allocation having Billing Start Date Prior to a Closed Pay Period. \n\n Once this Allocation is approved, the applicable "True-up/ Credit" amounts will be reflected in the Property Reimbursement reports for that Pay Period. \n\n Are you sure to save this record?';
    const aa = moment(updateData.billingStartDate);
    const bb = moment(lastClosedPayPeriodEndDate);
    if (selectedEditRowId.value > 0) {
      const marketAllocationsForSelectedDate = responseAllocationData.filter(y => y.allocationType === 'Market' && y.employeeId === updateData.employeeId && y.marketId !== updateData.marketId && moment(updateData.allocationStartDate).isBetween(moment(y.allocationStartDate), (moment(y.allocationEndDate).format('YYYY').toString() === '0001' ? moment(updateData.allocationStartDate).add(2, 'day') : moment(y.allocationEndDate))));
      const overallMarketAllocationPercentForSelectedDate = marketAllocationsForSelectedDate.reduce(function (prev, current) {
        return prev + +current.marketAllocationPercent;
      }, 0);
      const empPendingExists = responseAllocationData.find(x => x.allocationType === 'Market' && x.allocationId !== updateData.allocationId && x.employeeId === updateData.employeeId && x.marketId === updateData.marketId && x.divisionId === updateData.divisionId && x.departmentId === updateData.departmentId && x.approvalId === 3);
      const empExists = responseAllocationData.find(x => x.allocationType === 'Market' && x.allocationId !== updateData.allocationId && x.employeeId === updateData.employeeId && x.marketId === updateData.marketId && x.divisionId === updateData.divisionId && x.departmentId === updateData.departmentId && (x.approvalId === 4 || x.approvalId === 2));

      if (_.isEqual(updateData, previousEditRecord) && this.isEqual(updateData, previousEditRecord, updateData.allocationType)) {
        ShowToast('Please make any changes in the record or click on Cancel.', toastType.WARNING, 5000, 500);
      } else if (updateData.allocationType === 'Market' && empPendingExists !== undefined && this.isEditIconVisible(empPendingExists) && updateData.allocationId !== empPendingExists.allocationId && empPendingExists.approvalId === ApprovedStatus.PendingApproval
      ) {
        message = 'Employee: ' + empPendingExists.preferredName + '  already allocated to the Market: ' + empPendingExists.marketName + ' with Division: ' + empPendingExists.division + ' and Department: ' + empPendingExists.departmentName + '. If you want to update any information please edit that particular record. ';
        ShowToast(message, toastType.WARNING, 5000, 500);
      } else if (updateData.allocationType === 'Market' && empExists !== undefined && this.isEditIconVisible(empExists) && updateData.allocationId !== empExists.allocationId && (empExists.approvalId === ApprovedStatus.Approved || empExists.approvalId === ApprovedStatus.AutoAllocated)) {
        message = 'Employee: ' + empExists.preferredName + '  already allocated to the Market: ' + empExists.marketName + ' with Division: ' + empExists.division + ' and Department: ' + empExists.departmentName + '. If you want to update any information please edit that particular record. ';
        ShowToast(message, toastType.WARNING, 5000, 500);
      } else if (isPreviousToCurrentOrFuture && (updateData.approvalId.toString() === '4' || updateData.approvalId.toString() === '2')) {
        if (overallMarketAllocationPercentForSelectedDate + updateData.marketAllocationPercent > 100) {
          this.setState({ isPopupOpen: true, confirmationMessage: 'Current Overall Market Allocation Percentage exceeds 100 & This changes will be effective from selected date after approval. Are you sure to update this record?', postRecord: postRecord });
        } else {
          if (updateData.allocationType === 'Property' && moment(updateData.billingStartDate) <= moment(lastClosedPayPeriodEndDate)
            && (updateData.isReimbursed === true || (previousEditRecord.isReimbursed !== updateData.isReimbursed)) // Reimburse is True or Reimburse flag is changed
          ) {
            this.setState({ isPopupOpen: true, confirmationMessage: trueUpMsg, postRecord: postRecord });
          } else {
            this.setState({ isPopupOpen: true, confirmationMessage: 'This changes will be effective from selected date after approval. Are you sure to update this record?', postRecord: postRecord });
          }
        }
      } else if ((isDateInCurrentPayCycle(updateData.allocationStartDate) || isDateInNextPayCycle(updateData.allocationStartDate)) && (updateData.approvalId.toString() === '4' || updateData.approvalId.toString() === '2')) {
        postRecord.map((x) => {
          x.approvalStatusId = ApprovedStatus.PendingApproval;
          return x;
        });
        if (overallMarketAllocationPercentForSelectedDate + updateData.marketAllocationPercent > 100) {
          this.setState({ isPopupOpen: true, confirmationMessage: 'Current Overall Market Allocation Percentage exceeds 100. Are you sure to update this record?', postRecord: postRecord });
        } else {
          if (updateData.allocationType === 'Property' && moment(updateData.billingStartDate) <= moment(lastClosedPayPeriodEndDate)
            && (updateData.isReimbursed === true || (previousEditRecord.isReimbursed !== updateData.isReimbursed)) // Reimburse is True or Reimburse flag is changed
          ) {
            this.setState({ isPopupOpen: true, confirmationMessage: trueUpMsg, postRecord: postRecord });
          } else {
            this.saveAllocation(postRecord, selectedEditRowId);
          }
        }
      } else if ((updateData.marketAllocationPercent !== previousEditRecord.marketAllocationPercent || updateData.allocationStartDate !== previousEditRecord.allocationStartDate || updateData.allocationEndDate !== previousEditRecord.allocationEndDate) &&
        (updateData.approvalId.toString() === '4' || updateData.approvalId.toString() === '2')) {
        postRecord.map((x) => {
          x.approvalStatusId = ApprovedStatus.PendingApproval;
          return x;
        });
        if (overallMarketAllocationPercentForSelectedDate + updateData.marketAllocationPercent > 100) {
          this.setState({ isPopupOpen: true, confirmationMessage: 'Current Overall Market Allocation Percentage exceeds 100 & This changes will be effective from selected date after approval. Are you sure to update this record?', postRecord: postRecord });
        } else {
          if (updateData.allocationType === 'Property' && moment(updateData.billingStartDate) <= moment(lastClosedPayPeriodEndDate)
            && (updateData.isReimbursed === true || (previousEditRecord.isReimbursed !== updateData.isReimbursed)) // Reimburse is True or Reimburse flag is changed
          ) {
            this.setState({ isPopupOpen: true, confirmationMessage: trueUpMsg, postRecord: postRecord });
          } else {
            this.setState({ isPopupOpen: true, confirmationMessage: 'This changes will be effective from selected date after approval. Are you sure to update this record?', postRecord: postRecord });
          }
        }
      } else {
        postRecord.map((x) => {
          x.approvalStatusId = ApprovedStatus.PendingApproval;
          return x;
        });
        if (overallMarketAllocationPercentForSelectedDate + updateData.marketAllocationPercent > 100) {
          this.setState({ isPopupOpen: true, confirmationMessage: 'Current Overall Market Allocation Percentage exceeds 100. Are you sure to update this record?', postRecord: postRecord });
        } else {
          if (updateData.allocationType === 'Property' && moment(updateData.billingStartDate) <= moment(lastClosedPayPeriodEndDate)
            && (updateData.isReimbursed === true || (previousEditRecord.isReimbursed !== updateData.isReimbursed)) // Reimburse is True or Reimburse flag is changed
          ) {
            this.setState({ isPopupOpen: true, confirmationMessage: trueUpMsg, postRecord: postRecord });
          } else {
            this.saveAllocation(postRecord, selectedEditRowId);
          }
        }
      }
    } else if (updateData.allocationType === 'Market') {
      const empPendingExists = responseAllocationData.find(x => x.allocationType === 'Market' && x.employeeId === updateData.employeeId && x.marketId === updateData.marketId && x.divisionId === updateData.divisionId && x.departmentId === updateData.departmentId && x.approvalId === 3);
      const empExists = responseAllocationData.find(x => x.allocationType === 'Market' && x.employeeId === updateData.employeeId && x.marketId === updateData.marketId && x.divisionId === updateData.divisionId && x.departmentId === updateData.departmentId && (x.approvalId === 4 || x.approvalId === 2));
      const empExistsWithAntherMarket = responseAllocationData.filter(y => y.allocationType === 'Market' && y.employeeId === updateData.employeeId && y.marketId !== updateData.marketId && moment(updateData.allocationStartDate).isBetween(moment(y.allocationStartDate), (moment(y.allocationEndDate).format('YYYY').toString() === '0001' ? moment(updateData.allocationStartDate).add(2, 'day') : moment(y.allocationEndDate))));
      const marketAllocationsForSelectedDate = responseAllocationData.filter(y => y.allocationType === 'Market' && y.employeeId === updateData.employeeId && y.marketId !== updateData.marketId && moment(updateData.allocationStartDate).isBetween(moment(y.allocationStartDate), (moment(y.allocationEndDate).format('YYYY').toString() === '0001' ? moment(updateData.allocationStartDate).add(2, 'day') : moment(y.allocationEndDate))));
      const overallMarketAllocationPercentForSelectedDate = marketAllocationsForSelectedDate.reduce(function (prev, current) {
        return prev + +current.marketAllocationPercent;
      }, 0);

      if (empPendingExists !== undefined && empPendingExists.approvalId === ApprovedStatus.PendingApproval
      ) {
        message = 'Employee: ' + empPendingExists.preferredName + '  already allocated to the Market: ' + empPendingExists.marketName + ' with Division: ' + empPendingExists.division + ' and Department: ' + empPendingExists.departmentName + '. If you want to update any information please edit that particular record. ';
        isSave = false;
        isShowPopUp = false;
      } else if (empExists !== undefined && (empExists.approvalId === ApprovedStatus.Approved || empExists.approvalId === ApprovedStatus.AutoAllocated)) {
        message = 'Employee: ' + empExists.preferredName + '  already allocated to the Market: ' + empExists.marketName + ' with Division: ' + empExists.division + ' and Department: ' + empExists.departmentName + '. If you want to update any information please edit that particular record. ';
        isSave = false;
        isShowPopUp = false;
      } else if (empExistsWithAntherMarket !== undefined && empExistsWithAntherMarket.length > 0) {
        isShowPopUp = true;
        message = 'Employee: ' + empExistsWithAntherMarket[0].preferredName + ' is already allocated to other Market(s): ' + removeDuplicates(empExistsWithAntherMarket.map(x => x.marketName)).join(',') + '. Are you sure you want to continue?';
        if (overallMarketAllocationPercentForSelectedDate + updateData.marketAllocationPercent > 100) {
          message = 'Employee: ' + empExistsWithAntherMarket[0].preferredName + ' is already allocated to other Market(s): ' + removeDuplicates(empExistsWithAntherMarket.map(x => x.marketName)).join(',') +
            '. Also Current Overall Market Allocation Percentage exceeds 100' +
            '. Are you sure you want to continue?';
        }
      } else if (message !== '') {
        isSave = true;
      }
      if (!isSave && !isShowPopUp && message !== '') {
        ShowToast(message, toastType.WARNING, 5000, 500);
      } else if (!isSave && isShowPopUp && message !== '') {
        this.setState({ isPopupOpen: true, confirmationMessage: message, postRecord: postRecord });
      } else {
        message = 'Current Overall Market Allocation Percentage exceeds 100. Are you sure you want to continue?';
        if (overallMarketAllocationPercentForSelectedDate + updateData.marketAllocationPercent > 100) {
          this.setState({ isPopupOpen: true, confirmationMessage: message, postRecord: postRecord });
        } else {
          postRecord.map(x => {
            x.allocationId = 0;
          });
          this.saveAllocation(postRecord, selectedEditRowId);
        }
      }
    } else {
      const empData = postRecord.find(y => y.employeeId > 0);
      let employeeId;
      let legalEntityId;
      let propertyId;
      let pmaTitleId;
      let allocationStartDate;
      if (empData !== undefined) {
        employeeId = empData.employeeId;
        legalEntityId = empData.legalEntityId;
        propertyId = empData.propertyId;
        pmaTitleId = empData.pmaTitleId;
        allocationStartDate = empData.allocationStartDate;
      }
      const existingPendingRecord = responseAllocationData.find(y => y.employeeId === employeeId && y.legalEntityId === legalEntityId && y.approvalId === 3 && y.allocationType === 'Property' && y.pmaTitleId === pmaTitleId && y.recordSource !== 58 && (y.allocationEndDate === null || y.allocationEndDate === '' || y.allocationEndDate === '5000-01-01T00:00:00' || new Date(y.allocationEndDate) >= new Date(allocationStartDate.replace(/\//g, '-'))));
      if (existingPendingRecord !== undefined && existingPendingRecord.approvalId === ApprovedStatus.PendingApproval) {
        const data = responseAllocationData.find(y => y.employeeId === employeeId && y.propertyId === propertyId && y.approvalId === 3 && y.allocationType === 'Property' && y.pmaTitleId === pmaTitleId);
        if (data !== undefined && updateData.isAllocatedToLegalEntity === false) {
          if (parseInt(updateData.marketId) === 6 || parseInt(updateData.marketId) === 7) {
            message = 'Employee: ' + existingPendingRecord.preferredName + ' already allocated to the same Property: ' + data.propertyName + ' and PMA Title: ' + data.pmaTitle +
              '. If you want to update any information please edit that particular record.';
          } else {
            message = 'Employee: ' + existingPendingRecord.preferredName + ' already allocated to the same Property: ' + data.propertyName +
              '. If you want to update any information please edit that particular record.';
          }
        } else if (updateData.isAllocatedToLegalEntity === true) {
          if (parseInt(updateData.marketId) === 6 || parseInt(updateData.marketId) === 7) {
            message = 'Employee: ' + existingPendingRecord.preferredName + ' already allocated to the same Legal Entity: ' + existingPendingRecord.legalEntity + ' and PMA Title: ' + data.pmaTitle +
              '. If you want to update any information please edit that particular record.';
          } else {
            message = 'Employee: ' + existingPendingRecord.preferredName + ' already allocated to the same Legal Entity: ' + existingPendingRecord.legalEntity + // ' and PMA Title: ' + data.pmaTitle +
              '. If you want to update any information please edit that particular record.';
          }
        }
      } else {
        const employeeRecord = responseAllocationData.filter(y => y.employeeId === employeeId && y.legalEntityId === legalEntityId && y.approvalId === 4 && y.allocationType === 'Property' && y.pmaTitleId === pmaTitleId && y.recordSource !== 58 && (y.allocationEndDate === null || y.allocationEndDate === '' || y.allocationEndDate === '5000-01-01T00:00:00' || new Date(y.allocationEndDate) >= new Date(allocationStartDate.replace(/\//g, '-'))));
        employeeRecord.forEach(existingRecord => {
          if (existingRecord !== undefined && existingRecord.approvalId === ApprovedStatus.Approved) {
            const data = responseAllocationData.find(y => y.employeeId === employeeId && y.propertyId === propertyId && y.pmaTitleId === pmaTitleId &&
              y.approvalId === 4 && y.allocationType === 'Property');
            if (data !== undefined && updateData.isAllocatedToLegalEntity === false) {
              if (parseInt(updateData.marketId) === 6 || parseInt(updateData.marketId) === 7) {
                message = 'Employee: ' + existingRecord.preferredName + ' already allocated to the same Property: ' + data.propertyName + ' and PMA Title: ' + data.pmaTitle +
                  '. If you want to update any information please edit that particular record.';
              } else {
                message = 'Employee: ' + existingRecord.preferredName + ' already allocated to the same Property: ' + data.propertyName + // ' and PMA Title: ' + data.pmaTitle +
                  '. If you want to update any information please edit that particular record.';
              }
            } else if (updateData.isAllocatedToLegalEntity === true) {
              if (parseInt(updateData.marketId) === 6 || parseInt(updateData.marketId) === 7) {
                message = 'Employee: ' + existingRecord.preferredName + ' already allocated to the same Legal Entity: ' + existingRecord.legalEntity + ' and PMA Title: ' + data.pmaTitle +
                  '. If you want to update any information please edit that particular record.';
              } else {
                message = 'Employee: ' + existingRecord.preferredName + ' already allocated to the same Legal Entity: ' + existingRecord.legalEntity + // ' and PMA Title: ' + data.pmaTitle +
                  '. If you want to update any information please edit that particular record.';
              }
            }
          }
        });
      }
      if (message !== '' && message !== undefined && message !== null) {
        ShowToast(message, toastType.WARNING, 5000, 500);
      } else {
        postRecord.map(x => {
          x.allocationId = 0;
        });
        if (updateData.allocationType === 'Property' && moment(updateData.billingStartDate) <= moment(lastClosedPayPeriodEndDate)
          && updateData.isReimbursed === true // Reimburse is True for New Record
        ) {
          this.setState({ isPopupOpen: true, confirmationMessage: trueUpMsg, postRecord: postRecord });
        } else {
          this.saveAllocation(postRecord, selectedEditRowId);
        }
      }
    }
  }

  // Method is used to save new or updated allocation record if validation errors are not found
  saveAllocation = (postBodyData, selectedEditRowId) => {
    const allocationDataToStore = this.state.allocationData;
    this.setState({ isSave: true }, () => {
      apiPost({
        url: API_URL.Allocation.UpdateMultipleAllocation,
        params: {},
        postBody: postBodyData
      }).then(({ data: response }) => {
        if (response.success) {
          const msg = selectedEditRowId.value > 0 ? 'Record updated successfully.' : 'Record added successfully.';
          ShowToast(msg, toastType.SUCCESS, 5000, 500);
          allocationDataToStore.unshift();

          this._asyncRequest = apiBatchRequest([
            {
              url: API_URL.Allocation.GetAllocationData + this.childParameter(this.state.selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, this.state.selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected),
              key: 'allocationData'
            }
          ])
            .then(({ allocationData }) => {
              (allocationData.data || []).forEach(x => {
                if (x.allocationEndDate === undefined || x.allocationEndDate === '0001-01-01T00:00:00') {
                  x.allocationEndDate = '5000-01-01T00:00:00';
                }
                if (x.isSwapAllocation === 1 && x.parentSwapAllocationId > 0 && x.parentSwapAllocationId !== x.allocationId) {
                  const employeeName = allocationData.data?.find(z => z.allocationId === x.parentSwapAllocationId)?.preferredName || '';
                  x.tooltip = 'This is the record created for swapping of Employee ' + employeeName + ' with ' + x.preferredName + ' for Property ' + x.propertyName + '';
                }
              });
              this.setState({
                isSave: false,
                isEditableMode: false,
                responseAllocationData: allocationData.data || [],
                configuration: allocationData.config,
                allocationData: applyFilterOnData(
                  allocationData.data || [],
                  this.state.selectedData
                ),
                isTerminationPopupOpen: false,
                TerminationConfirmationMessage: '',
                updateData: undefined,
                allocationTerminationColumn: [],
                mode: '',
                previousEditRecord: undefined,
                allocationColumns: cloneDeep(allocationColumnsList)
              });
            })
            .catch(() => {
              this._asyncRequest = null;
            });

          this.setState({
            isSave: false,
            allocationData: allocationDataToStore,
            selectedEditRowId: undefined,
            isInAddMode: false,
            EditedAllcoationRecord: 0,
            updateData: undefined,
            isTerminationPopupOpen: false,
            TerminationConfirmationMessage: '',
            allocationTerminationColumn: [],
            mode: '',
            previousEditRecord: undefined,
            allocationColumns: cloneDeep(allocationColumnsList)
          });
        } else {
          //   ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
          this.setState({
            isSave: false
          });
        }
      });
    });
  }

  // Method is used to display a form to create new allocation record
  AddNewRecord = () => {
    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const allocationColumns = cloneDeep(allocationColumnsList);
    const allocationType = this.props.allocationType !== undefined ? this.props.allocationType[0].allocationType : this.state.selectedAllocationType;
    let employeeName = null;
    let marketName = null;
    let departmentId = 0;
    let departmentName = '';
    let burdenRate = '';
    let category = '';
    let overallMarketAllocationPercent = 0;
    let overallPropertyAllocationPercent = 0;
    let overallPropertyBillingPercent = 0;
    let serviceTypeId = 0;
    let serviceType = '';
    let marketId = 0;

    if (this.props.selectedEmployeeId > 0) {
      employeeName = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).employeeName;
      departmentName = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).departmentName;
      departmentId = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).departmentId;
      serviceTypeId = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).serviceTypeId;
      serviceType = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).serviceType;
      if (serviceType !== 'Property Accounting') {
        marketId = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).marketId;
        marketName = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).marketName;
      }
      if (this.props.allocationType !== undefined && this.props.allocationType[0].allocationType === 'Property') {
        burdenRate = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).burdenRate;
        category = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).category;
      }
      overallMarketAllocationPercent = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).overallMarketAllocationPercent;
      overallPropertyAllocationPercent = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).overallPropertyAllocationPercent;
      overallPropertyBillingPercent = (this.state.employeeMasterData.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).overallPropertyBillingPercent;
    }
    let allocationStartDate = null; let billingStartDate = null;
    if (this.props.selectedPropertyId > 0 || this.props.selectedEmployeeId > 0) {
      allocationStartDate = moment(getCurrentPayCycleStartDate()).format(DateFormat);
      billingStartDate = moment(getCurrentPayCycleStartDate()).format(DateFormat);
    }
    if (this.props.marketId > 0) {
      marketName = (this.state.marketMasterData.find(x => x.marketId === parseInt(this.props.marketId)) || {}).marketName;
    }
    const allocType = this.props.allocationType !== undefined ? this.props.allocationType[0].allocationType : this.state.selectedAllocationType;
    const rowNew = {
      allocationId: 0,
      employeeId: this.props.selectedEmployeeId > 0 ? this.props.selectedEmployeeId : 0,
      preferredName: employeeName,
      departmentId: departmentId > 0 ? departmentId : 0,
      departmentName: departmentName,
      marketId: this.props.marketId > 0 ? this.props.marketId : marketId,
      marketName: marketName,
      allocationType: this.props.allocationType !== undefined ? this.props.allocationType[0].allocationType : this.state.selectedAllocationType,
      divisionId: 0,
      division: '',
      pmaTitleId: 0,
      pmaTitle: '',
      propertyId: 0,
      propertyName: '',
      propertyTypeId: 0,
      propertyTypeName: null,
      allocationStartDate: allocationStartDate,
      allocationEndDate: null,
      billingStartDate: billingStartDate,
      billingEndDate: null,
      marketAllocationPercent: 0,
      propertyAllocationPercent: 0,
      propertyBillingPercent: 0,
      overallMarketAllocationPercent: overallMarketAllocationPercent,
      overallMarketBillingPercent: 0,
      overallPropertyAllocationPercent: overallPropertyAllocationPercent,
      overallPropertyBillingPercent: overallPropertyBillingPercent,
      additionalFixedAmount: 0,
      rateValue: 0,
      isReimbursed: allocType === 'Market',
      isApproved: false,
      statusId: 0,
      statusName: null,
      legalEntityId: 0,
      isAllocatedToLegalEntity: false,
      burdenRate: burdenRate,
      category: category,
      propertyTransitionId: ''
    };
    this.setState({
      isSave: false,
      isInAddMode: true,
      selectedEditRowId: { key: 'allocationId', value: 0 },
      updateData: rowNew,
      allocationColumns
    }, () => {
      this.getPropertyDataFromDate(rowNew.allocationStartDate, rowNew.billingStartDate, rowNew.allocationEndDate, rowNew.billingEndDate, rowNew);
    });
  };

  // Method is used to delete the allocation record.
  DeleteAllocation = () => {
    const { updateData } = this.state;
    const allocationDataToStore = this.state.allocationData;
    const params = {
      allocationId: updateData.allocationId,
      allocationType: updateData.allocationType,
      marketName: updateData.marketName,
      propertyName: updateData.propertyName,
      departmentId: updateData.departmentId,
      serviceTypeId: updateData.serviceTypeId,
      marketId: updateData.marketId
    };
    apiDelete({
      url: API_URL.Allocation.DeleteAllocation,
      params
    }).then(({ data }) => {
      if (data.success) {
        ShowToast('Record deleted successfully.', toastType.SUCCESS, 5000, 500);
        allocationDataToStore.unshift();

        this._asyncRequest = apiBatchRequest([
          {
            url: API_URL.Allocation.GetAllocationData + this.childParameter(this.state.selectedData.find(x => x.key === 'onlyActiveAllocation')?.selected[0]?.onlyActiveAllocation === true, this.state.selectedData.find(x => x.key === 'ultiProEmployeeId')?.selected),
            key: 'allocationData'
          }
        ])
          .then(({ allocationData }) => {
            (allocationData.data || []).forEach(x => {
              if (x.allocationEndDate === undefined || x.allocationEndDate === '0001-01-01T00:00:00') {
                x.allocationEndDate = '5000-01-01T00:00:00';
              }
              if (x.isSwapAllocation === 1 && x.parentSwapAllocationId > 0 && x.parentSwapAllocationId !== x.allocationId) {
                const employeeName = allocationData.data?.find(z => z.allocationId === x.parentSwapAllocationId)?.preferredName || '';
                x.tooltip = 'This is the record created for swapping of Employee ' + employeeName + ' with ' + x.preferredName + ' for Property ' + x.propertyName + '';
              }
            });
            this.setState({
              responseAllocationData: allocationData.data || [],
              configuration: allocationData.config,
              allocationData: applyFilterOnData(
                allocationData.data || [],
                this.state.selectedData
              )
            });
          })
          .catch(() => {
            this._asyncRequest = null;
          });

        this.setState({
          allocationData: allocationDataToStore,
          selectedEditRowId: undefined,
          isInAddMode: false,
          EditedAllcoationRecord: 0,
          updateData: undefined
        });
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
      }
    });
  }

  // Event to handle operations on Confirmation box while update or delete the allocation record
  onPopupClickHandle = (value) => {
    const { selectedEditRowId, postRecord, isDelete } = this.state;
    if (value) {
      if (isDelete) {
        this.DeleteAllocation();
        this.setState({ isPopupOpen: false, confirmationMessage: '', isDelete: false });
      } else {
        this.saveAllocation(postRecord, selectedEditRowId);
      }
      this.setState({ isPopupOpen: false, confirmationMessage: '', isPreviousToCurrentOrFuture: false });
    } else {
      this.setState({ isPopupOpen: false, confirmationMessage: '' });
    }
  }

  // Method is used to render the components based on the conditions
  render() {
    const {
      employeeMasterData,
      propertyMasterData,
      filterPropertyMasterData,
      propertyTypeMasterData,
      departmentMasterData,
      marketMasterData,
      configuration,
      selectedData,
      updateData,
      isPopupOpen,
      confirmationMessage,
      allocationColumns,
      statusMasterData,
      divisionMasterData,
      departmentFilteredMasterData,
      pmaTitleMasterData
    } = this.state;
    let empDataForAllocation = cloneDeep(employeeMasterData);
    const serviceTypeList = GetReadOnlyServiceType();

    empDataForAllocation = empDataForAllocation.filter(y => serviceTypeList.find(x => x.serviceTypeId.toString() === y.serviceTypeId.toString()) === undefined);
    const hiddenConfig = [];
    const EditSource = [];
    EditSource.push(
      { key: 'employeeMasterData', data: (empDataForAllocation || []).filter(x => x.employeeStatus === true) },
      { key: 'marketMasterData', data: marketMasterData },
      { key: 'departmentMasterData', data: departmentMasterData },
      { key: 'propertyMasterData', data: propertyMasterData },
      { key: 'divisionMasterData', data: divisionMasterData },
      { key: 'departmentFilteredMasterData', data: departmentFilteredMasterData },
      { key: 'pmaTitleMasterData', data: pmaTitleMasterData }
    );
    let showAdd = false;
    const allocationType =
      selectedData.find((x) => x.key === 'allocationType') || {};
    if (
      allocationType &&
      allocationType.selected &&
      allocationType.selected.length === 1
    ) {
      hiddenConfig.push({
        key: 'allocationType',
        value: allocationType.selected[0].allocationType
      });
      if (allocationType.selected[0].allocationType === 'Market') {
        showAdd = IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION) &&
          IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION, SECTIONS.ADD_EDIT);
      } else if (allocationType.selected[0].allocationType === 'Property') {
        showAdd = IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION) &&
          IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION, SECTIONS.ADD_EDIT);
      }
    }
    if (showAdd) {
      showAdd = !(this.props.clientId === null || this.props.clientId === 0);
    }

    if (showAdd) {
      if (this.props.selectedEmployeeId !== undefined && (this.props.selectedEmployeeId > 0 || this.props.selectedEmployeeId.toString() !== undefined || this.props.selectedEmployeeId.toString() !== null ||
        this.props.selectedEmployeeId.toString() !== '')) {
        const empData = employeeMasterData.find(x => x.employeeId.toString() === this.props.selectedEmployeeId.toString());
        if (empData !== undefined) {
          const serviceTypeList = GetReadOnlyServiceType();
          if (serviceTypeList.find(x => x.serviceTypeId.toString() === empData.serviceTypeId.toString()) !== undefined) {
            showAdd = false;
          }
        }
      }
    }
    const searchAllocationRadio = [];
    if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION)) {
      searchAllocationRadio.push({ value: 'Market', title: 'Market Allocation' });
    }
    if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION)) {
      searchAllocationRadio.push({ value: 'Property', title: 'Property Allocation' });
    }
    const filterConfigRef = [
      {
        multiple: true,
        type: controlType.DropDown,
        source: marketMasterData,
        key: 'marketName',
        placeholder: 'Search Market',
        title: 'Market'
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: departmentMasterData,
        key: 'departmentName',
        placeholder: 'Search Department',
        title: 'Department'
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: divisionMasterData,
        key: 'division',
        placeholder: 'Search Division',
        title: 'Division',
        hidewhen: { key: 'allocationType', value: 'Property' },
        hideFilter: ((this.props.renderAsChild === true &&
          ((this.props.allocationType || [])[0] || {}).allocationType !== 'Market'))
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: propertyTypeMasterData,
        key: 'propertyTypeName',
        placeholder: 'Search Property type',
        title: 'Property Type',
        hidewhen: { key: 'allocationType', value: 'Market' },
        hideFilter: ((this.props.renderAsChild === true &&
          ((this.props.allocationType || [])[0] || {}).allocationType !== 'Property'))
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: filterPropertyMasterData,
        key: 'propertyName',
        placeholder: 'Search Property',
        title: 'Property Name',
        hidewhen: { key: 'allocationType', value: 'Market' },
        allowreset: !((this.props.renderAsChild === true &&
          this.props.selectedPropertyId !== undefined)),
        hideFilter: ((this.props.renderAsChild === true &&
          ((this.props.allocationType || [])[0] || {}).allocationType !== 'Property'))
      },
      {
        type: controlType.DatePicker,
        key: 'allocationStartDate',
        placeholder: 'Search Property',
        title: 'Allocation Start Date'
      },
      {
        type: controlType.DatePicker,
        key: 'billingStartDate',
        placeholder: 'Search Property',
        hidewhen: { key: 'allocationType', value: 'Market' },
        title: 'Billing Start Date',
        operator: Operators.GreaterThanEqualsTo

      },
      {
        type: controlType.DatePicker,
        key: 'billingEndDate',
        placeholder: 'Search Property',
        hidewhen: { key: 'allocationType', value: 'Market' },
        title: 'Billing End Date',
        operator: Operators.LessThanEqualsTo
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: employeeMasterData,
        key: 'employeeName',
        placeholder: 'Search Employee',
        title: 'Employee',
        allowreset: !((this.props.renderAsChild === true &&
          this.props.selectedEmployeeId !== undefined)),
        ignoreFilters: ['propertyTypeName', 'propertyName', 'departmentName', 'marketName']
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: employeeMasterData,
        key: 'ultiProEmployeeId',
        filterOnKey: 'supervisorId',
        displayValue: 'employeeName',
        placeholder: 'Search Supervisor',
        title: 'Supervisor',
        alwaysFromServer: true,
        hideFilter: (this.props.renderAsChild === true && this.props.selectedEmployeeId !== undefined),
        allowreset: !((this.props.renderAsChild === true &&
          this.props.selectedEmployeeId !== undefined)),
        ignoreFilters: ['propertyTypeName', 'propertyName', 'departmentName', 'marketName']
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: statusMasterData,
        key: 'approvalStatus',
        placeholder: 'Search Status',
        title: 'Status'
      },
      {
        type: controlType.Checkbox,
        key: 'employeeStatus',
        placeholder: 'Search Property',
        title: 'Show Only Active Employees'
      },
      {
        type: controlType.Checkbox,
        key: 'onlyActiveAllocation',
        placeholder: 'Search Property',
        title: 'Show InActive/ Historical Allocation(s)'
      },
      {
        type: controlType.Checkbox,
        key: 'onlyReimbursable',
        placeholder: 'Search Property',
        title: 'Show Only Reimbursable',
        hidewhen: { key: 'allocationType', value: 'Market' }
      }

    ];
    const filterConfig = [
      {
        type: controlType.RadioButton,
        key: 'allocationType',
        options: searchAllocationRadio,
        placeholder: 'Search Property',
        title: 'Allocation Type',
        hiddenWhenChild: this.props.renderAsChild === true,
        isHandleClick: true,
        resetFilter: ['propertyTypeName', 'propertyName', 'billingStartDate', 'billingEndDate'],
        allowreset: false
      },
      ...filterConfigRef
    ];
    const filterConfigChild = [
      ...filterConfigRef,
      {
        type: controlType.RadioButton,
        key: 'allocationType',
        options: searchAllocationRadio,
        placeholder: 'Search Property',
        title: 'Allocation Type',
        hiddenWhenChild: this.props.renderAsChild === true,
        isHandleClick: true,
        resetFilter: ['propertyTypeName', 'propertyName', 'billingStartDate', 'billingEndDate'],
        allowreset: false
      }
    ];

    return (
      <>
        {
          this.state.isTerminationPopupOpen &&
          <DailogBoxwithControls
            IsOpen={this.state.isTerminationPopupOpen}
            Message={this.state.TerminationConfirmationMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onTerminationPopupClick(isValid);
              } else {
                this.onTerminationPopupClick(isValid);
              }
            }}
            AgreeText="Submit"
            DisAgreeText="Cancel"
            columns={this.state.allocationTerminationColumn}
            data={this.state.updateData}
            handleTableEditChange={this.handleTerminationAllocationChange}
            renderDynamicForm={this.renderDynamicForm}
          />
        }
        {isPopupOpen && (
          <ConfirmDialog
            IsOpen={isPopupOpen}
            Message={confirmationMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopupClickHandle(isValid);
              } else {
                this.onPopupClickHandle(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          />
        )}
        {this.props.renderAsChild !== true && (
          <PageHeader title="Allocations"></PageHeader>
        )}
        {(this.props.clientId === null || this.props.clientId === 0) && (<label style={{ fontWeight: '700', marginLeft: '25px', color: 'red' }} > Property {this.props.propertyName} does not have any active PTF or Services. Employee Allocations can be done after a PTF is created for the Property.</label>)
        }
        <PageFilter
          autoFilter={false}
          filterAlwaysVisible={this.props.renderAsChild !== true}
          onFilterChanged={this.onFilterChange}
          resetPage={(this.state.isAutoRunEnabled || this.props.renderAsChild) ? undefined : this.resetPage}
          filterConfig={this.props.renderAsChild ? filterConfigChild : filterConfig}
          defaultSelectedData={this.state.defaultSelectedData}
          selectedData={selectedData}
          gridColumn={3}
        ></PageFilter>
        {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
        {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) &&
          (this.state.allocationData === null || this.state.allocationData.length <= 0) &&
          this.props.renderAsChild !== true &&
          (
            <PageLandingMessage buttonName={'SEARCH'} />
          )
        }
        <div className="row table-list-container">
          {this.state.allocationData &&
            (this.props.renderAsChild || this.state.isAutoRunEnabled === true || (this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === true)) &&
            <GridTable
              columns={UpdateColumnWithConfiguration(
                allocationColumns,
                configuration || [],
                hiddenConfig || []
              )}
              data={this.state.allocationData || []}
              config={allocationConfig}
              renderActionColumn={this.renderActionColumn}
              selectedEditRowId={this.state.selectedEditRowId}
              isInAddMode={this.state.isInAddMode}
              EditSource={EditSource}
              handleTableEditChange={this.handleTableEditChange}
              updateData={updateData}
              AddNewRecord={{
                action: this.AddNewRecord,
                title: 'Add New Allocation',
                visible: showAdd
              }}
              rowBadge={{
                key: 'approvalId',
                equalsTo: 2,
                class: 'message rotate-badge',
                title: 'New',
                tooltip: 'This is the new auto allocated record received from UltiPro',
                separateBySpace: true
              }}
              swapBadge={{
                key: 'parentSwapAllocationId',
                notEqualsTo: 0,
                referenceKey: 'allocationId',
                class: 'message rotate-badge',
                title: 'AS', // 'Auto Swap',
                tooltip: 'This is the record created for swapping of employee ',
                separateBySpace: true
              }}
              gracePeriodBadge={{
                key: 'recordSource',
                equalsTo: RECORD_SOURCE.GRACE_PERIOD,
                referenceKey: 'recordSource',
                class: 'message rotate-badge',
                title: 'GP', // Extended Period',
                tooltip: 'This is the record created for Extended Grace Period Allocation of Property Accounting ',
                separateBySpace: true
              }}
              renderDynamicForm={this.renderDynamicForm}
              isEditableMode={this.state.isEditableMode}
              reload={this.state.reloadtable}
            ></GridTable>}
        </div>
      </>
    );
  }
}

export default Allocations;
